/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import cssClasses from "./Register.module.css";
import { useNavigate } from "react-router-dom";
import { supabase } from '../../../src/supabaseClient';
import AskFirmNameDialog from './AskFirmNameDialog';
import { toast } from "react-toastify";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
// import Accordion from "@mui/material/Accordion";
// import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FullScreenLoader from "../Profile/FullScreenLoader";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button as MUIButton
} from "@mui/material";
import ReraUploadModal from "./ReraUploadModal"; // adjust path
import { parseCertificateText } from "../../Services/SmsService";



//subComponent
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import Dropdown from "../../Subcomponents/DropDown";

import RightArrow from "../Icons/RightArrow";

import { useTheme } from "@mui/material/styles";
import MobileStepper from "@mui/material/MobileStepper";
import { styled } from "@mui/material/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import copy from "copy-to-clipboard";

import CircularProgress from "@mui/material/CircularProgress";
//images
import backArrow from "../../Assets/Images/backArrow.svg";
import block from "../../Assets/Images/block.svg";
import logo from "../../Assets/Images/Logo.png";
import uploadFile from "../../Assets/Images/uploadFile.svg";
import greenCheckedIcon from "../../Assets/Images/greenChecked.svg";
import InfoIcon from "../../Components/Icons/InfoIcon";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import Countdown, { zeroPad } from "react-countdown";

import { dismissLoader, presentLoader } from "../../Services/loader";
import TermsAndConditionJson from "./TermsAndConditons.json";
//
import debounce from "lodash.debounce";
//services
import {
  getPAN_cardDetails,
  getAccountDetails,
  getGSTNumber,
  getGSTInfo,
  getReraDetails,
} from "../../Services/SurepassApi";
import {
  signUpCP,
  addKYCDoc,
  getCpId,
  uploadFileToDb,
  getCPUId,
  getSalesPerson,
  checkCPExists,
  checkFOSExists,
  checkBillingNameExists,
  checkBillingNameExistsInFos,
  handleErrors,
  checkPanNumberExists,
  checkPhoneExistsApi
} from "../../Services/LoginService";
import {
  sendOTPMessage,
  sendMailTo,
  readReraPdfFile,
  readingPdf,
  sendMessage,
  sendOTPMessageMail,
} from "../../Services/SmsService";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import { errorTost, successTost, offlineToast } from "../../Services/Toast";
import { Network } from "@capacitor/network";
//AutoComplete
import Paper from "@material-ui/core/Paper";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { checkPhoneNumberIsBlackListed } from "../../Services/LeadService";
import CountdownTimer from "../../Subcomponents/CountDownTimer";

import CryptoJS from "crypto-js";
import { Accordion, AccordionSummary } from "@mui/material";
const useStyles = makeStyles((theme) => ({
  textStyle: {
    fontSize: "1.6rem ",
    fontFamily: "Inter-Medium",
    lineHeight: "2.4rem ",
    borderBottom: "1px solid #F2F4F7",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    // padding:'0.5rem 1rem',
  },
  customTextField: {
    "& input::placeholder": {
      fontSize: "1.6rem !important",
    },
  },
  radioLabel: {
    fontFamily: "Inter-Medium !important",
    fontSize: "1.6rem",
    lineHeight: "2.5rem",
  },
  stepper: {
    "& .MuiLinearProgress-root": {
      backgroundColor: "rgba(82, 108, 130, 0.1) !important",
      height: "0.8rem !important",
      borderRadius: "5rem !important",
      width: "100% !important",
      "& .MuiLinearProgress-bar": {
        backgroundColor: "#155EEF !important",
      },
    },
  },
}));
const AutoCompleTheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: "1.6rem !important",
          fontFamily: "Inter-Medium !important",
          lineHeight: "2.4rem !important",
          borderRadius: 20,
          borderColor: "#84CAFF !important",
          paddingRight: "3rem !important",
          padding: "0.5rem 1.4rem !important",
          "& input[text]": {
            color: "#101828 !important",
          },
          "& input[input:-internal-autofill-selected]": {
            background: "#F2F4F7 !important",
            borderBottom: "1px solid #878383 !important",
          },
          "& input[value]": {
            background: "#FFFFF !important",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none !important",
          },
          "&.Mui-focused": {
            background: "#FFFFFF !important",
            border: "1px solid #84CAFF !important",

            boxShadow:
              "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF !important",
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& label": {
            fontSize: "1.6rem !important",
          },
        },
      },
    },
  },
});
export default function Login() {
  const navigate = useNavigate();
  const classes = useStyles();
  const theme = useTheme();
  const [hideBackButton, setHideBackButton] = useState(false);
  const [type, setType] = useState("CP");
  const [cpType, setCPType] = useState("");
  const [reraStartDate, setReraStartDate] = useState("");
  const [reraEndDate, setReraEndDate] = useState("");
  const [agentType, setAgentType] = useState("");
  const [askFirmNameDialog, setAskFirmNameDialog] = useState(false);
  const [showProprietorshipDialog, setShowProprietorshipDialog] = useState(false);
  const [firmName, setFirmName] = useState("");
  const [shopActFile, setShopActFile] = useState(null);
  const [showUpload, setShowUpload] = useState(false);
  const [showReraUploadDialog, setShowReraUploadDialog] = useState(false);








  const [cpDetails, setCpDetails] = useState({
    panNumber: "",
    panObject: {},
    reraObject: {},
    gstObject: {},
    gstApplicable: "true",
    gstNumber: "",
    billingName: "",
    reraNumber: "",
    reraDocument: "",
    reraDocumentName: "",
    recomendation: "",
    msmeAvalaible: "",
    msmeNumber: "",
    docUrl: "",
    isFlagged: false,
  });
  const [personDetail, setPersonDetail] = useState({
    personaName: "",
    phoneNumber: "",
    email: "",
    password: "",
  });
  const [bankDetails, setBankDetails] = useState({
    holderName: "",
    accountNumber: "",
    ifscCode: "",
    branchName: "",
  });
  const [reraFileUpload, setReraFileUpload] = useState("");
  const [MSMEList, setMSMEList] = useState([
    "Micro",
    "Small",
    "Medium",
    "Not Applicable",
  ]);
  const [showOtp, setShowOtp] = useState(false);

  const [state, setState] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  });
  const [showEmailOtp, setShowEmailOtp] = useState(false);
  const [emailState, setEmailState] = useState({
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
  });
  const [recievedEmailOtp, setRecievedEmailOtp] = useState(null);
  const [otptimerEmail, setOtpTimerEmail] = useState(false);
  const [emailLabelText, setEmailLabelText] = useState("");
  const [verifiedEmail, setVerifiedEmail] = useState(false);

  const [isInterNational, setIsInterNational] = useState(false);
  const [recievedOtp, setRecievedOtp] = useState(null);
  const [otptimer, setOtpTimer] = useState(false);
  const [verifiedPhoneNumber, setVerifiedPhoneNumber] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [totalSteps, setTotalStep] = useState(7);
  const [activeStep, setActiveStep] = React.useState(1);
  const [helperText, setHelperText] = useState({
    isPanValid: "",
    reraVerified: false,
    panVerified: false,
    gstNumberVerified: false,
    bankDetailsIsVerified: false,
    // isGstApplicable: true,
    isGstNumber: "",
    isBillingName: "",
    reraNumber: "",
    reraDocument: "",
    isMemeNumber: "",
    msmeNumber: "",
    salesPersonName: "",
    isPersonName: "",
    isPhoneNumber: "",
    isEmail: "",
    isPassword: "",
    isHolderName: "",
    isAccountNumber: "",
    isIfscCode: "",
    isBranchName: "",
  });
  const [billingNameDisabled, setBillingNameDisabled] = useState(false);
  const [cpButtonNext, setCpButtonNext] = useState(false);
  const [personalButtonNext, setPersonalButtonNext] = useState(false);
  const [bankButtonNext, setBankButtonNext] = useState(false);
  const [isLoadingPan, setIsLoadingPan] = useState(false);
  const [panCategory, setPanCategory] = useState("");
  const [isLoadingIfSC, setIsLoadingIfSC] = useState(false);
  const [isLoadingAccount, setIsLoadingAccount] = useState(false);
  const [isReraLoading, setIsReraLoading] = useState(false);
  const [isGSTLoading, setIsGSTLoading] = useState(false);
  const [isLoadingEmail, setIsLoadingEmail] = useState(false);
  const [isLoadingPhone, setIsLoadingPhone] = useState(false);
  const [ledgerName, setLedgerName] = useState("");
  const [gstArray, setGstArray] = useState([]);
  const [message, setMessage] = useState("");
  const [salesPersonArray, setSalesPersonArray] = useState([]);
  const [cpDispalyId, setCpDisplayId] = useState("");
  const [progress, setProgress] = useState(0);
  const [counting, setCounting] = useState(10);
  const [acceptTermsAndConditions, setAcceptTermsAndConditions] =
    useState(false);
  const [resendButton, setResendButton] = useState(false);
  const startDate = React.useRef(Date.now());
  const [reraPopUp, setReraPopUp] = useState(false);
  const [reraPopUpYesSelected, setReraPopUpYesSelected] = useState(false);

  const [activeGSTOptions, setActiveGSTOptions] = useState([]); // Add this state at top
  const [fetchedGstFromPan, setFetchedGstFromPan] = useState(""); // GST fetched from PAN

  useEffect(() => {
    if (fetchedGstFromPan && cpDetails.gstNumber !== fetchedGstFromPan) {
      console.log("User changed the auto-filled GST number.");
      // You can show a warning or indicator if needed
    }
  }, [cpDetails.gstNumber, fetchedGstFromPan]);




  useEffect(() => {
    // console.log(progress);
    if (activeStep === 6) {
      const timer = setInterval(() => {
        setProgress((prevProgress) =>
          prevProgress >= 100 ? 0 : prevProgress + 10
        );
        setCounting(counting - 1);
        // console.log(progress);
      }, 1000);
      console.log(timer);
      return () => {
        console.log(timer);
        clearInterval(timer);
      };
    }
  }, [activeStep, counting]);
  useEffect(() => {
    if (progress === 100) {
      navigate("/Login");
    }
  }, [progress]);

  useEffect(() => {
    console.log(cpType);
  }, [cpType]);

  useEffect(() => {
    let validation = validateCpDetailsForButton();
    if (validation.flag) {
      setCpButtonNext(true);
    } else {
      setCpButtonNext(false);
    }
  }, [cpButtonNext, validateCpDetailsForButton]);
  useEffect(() => {
    let validation = validatePersonalDetailsForButton();
    if (validation.flag) {
      setPersonalButtonNext(true);
    } else {
      setPersonalButtonNext(false);
    }
  }, [personalButtonNext, validatePersonalDetailsForButton]);
  useEffect(() => {
    let validation = validateBankDetailsForButton();
    if (validation.flag) {
      setBankButtonNext(true);
    } else {
      setBankButtonNext(false);
    }
  }, [bankButtonNext, validateBankDetailsForButton]);

  const getSalesPersonDetails = useRef(
    debounce((e) => {
      console.log(e);
      if (e !== "") {
        getSalesPerson(e)
          .then((resp) => {
            console.log(resp);
            if (resp.length !== 0) {
              setSalesPersonArray(resp);
              setHelperText((pre) => {
                pre.salesPersonName = "";
                return { ...pre };
              });
            } else {
              helperText.salesPersonName = "";
              setSalesPersonArray([]);
              setCpDetails((pre) => {
                pre.recomendation = "";
                return { ...pre };
              });
              setHelperText((pre) => {
                pre.salesPersonName = "";
                return { ...pre };
              });
            }
          })
          .catch((err) => {
            errorTost(err.message);
            setSalesPersonArray([]);
            setCpDetails((pre) => {
              pre.recomendation = "";
              return { ...pre };
            });
          });
      } else {
        setSalesPersonArray([]);
        setCpDetails((pre) => {
          pre.recomendation = "";
          return { ...pre };
        });
      }
    }, 800)
  ).current;

  function clearAllData() {
    setAcceptTermsAndConditions(false);
    setCpDetails((pre) => {
      pre.panNumber = "";
      pre.panObject = {};
      pre.reraObject = {};
      pre.gstObject = {};
      pre.gstApplicable = "true";
      pre.gstNumber = "";
      pre.billingName = "";
      pre.reraNumber = "";
      pre.reraDocument = "";
      pre.reraDocumentName = "";
      pre.recomendation = "";
      pre.msmeAvalaible = "";
      pre.docUrl = "";
      pre.isFlagged = false;

      return { ...pre };
    });
    setPersonDetail((pre) => {
      pre.email = "";
      pre.password = "";
      pre.personaName = "";
      pre.phoneNumber = "";
      return { ...pre };
    });
    setBankDetails((pre) => {
      pre.accountNumber = "";
      pre.branchName = "";
      pre.holderName = "";
      pre.ifscCode = "";
      return { ...pre };
    });
    setHelperText((pre) => {
      pre.isPanValid = "";
      pre.reraVerified = false;
      pre.panVerified = false;
      pre.gstNumberVerified = false;
      pre.bankDetailsIsVerified = false;
      // isGstApplicable: true;
      pre.isGstNumber = "";
      pre.isBillingName = "";
      pre.reraNumber = "";
      pre.reraDocument = "";
      pre.isMemeNumber = "";
      pre.msmeNumber = "";
      pre.salesPersonName = "";
      pre.isPersonName = "";
      pre.isPhoneNumber = "";
      pre.isEmail = "";
      pre.isPassword = "";
      pre.isHolderName = "";
      pre.isAccountNumber = "";
      pre.isIfscCode = "";
      pre.isBranchName = "";
      return { ...pre };
    });
    setState((pre) => {
      pre.otp1 = "";
      pre.otp2 = "";
      pre.otp3 = "";
      pre.otp4 = "";
      return { ...pre };
    });
  }
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    console.log(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    console.log(activeStep);
    if (activeStep === 1) {
      navigate("/Login");
    }
    if (activeStep === 2) {
      clearAllData();
    }
  };
  function optChange(value1, event) {
    event.preventDefault();
    setState((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }
  function submitOtp() {
    let finalValue = state.otp1 + state.otp2 + state.otp3 + state.otp4;
    console.log(finalValue, "recievedOtp", recievedOtp);
    if (finalValue == recievedOtp) {
      setVerifiedPhoneNumber(true);
      setShowOtp(false);
      setOtpTimer(false);
      setHelperText((pre) => {
        pre.isPhoneNumber = "";
        return { ...pre };
      });
    } else {
      setState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      errorTost("OTP doesnt match.Please enter valid otp");
    }
  }
  function smsTimeOut() {
    console.log({ verifiedPhoneNumber })
    if (verifiedPhoneNumber === false) {
      setHelperText((pre) => {
        pre.isPhoneNumber = "Otp has expired.Please resend otp";
        return { ...pre };
      });
      setVerifiedPhoneNumber(false);
      setShowOtp(true);
      setResendButton(true);
      setOtpTimer(true);
      setState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      recievedOtp(null);
    }
  }
  // function smsApiCall() {
  //   setResendButton(false);
  //   // const myTimeout = setTimeout(() => {
  //   //   setResendButton(true);
  //   // }, 180000);
  //   setState((pre) => {
  //     pre.otp1 = "";
  //     pre.otp2 = "";
  //     pre.otp3 = "";
  //     pre.otp4 = "";
  //     return { ...pre };
  //   });
  //   setShowOtp(true);
  //   let body = {
  //     number: personDetail.phoneNumber,
  //     isInterNational: isInterNational,
  //   };
  //   console.log(body);
  //   sendOTPMessage(body)
  //     .then((resp) => {
  //       if (resp.data.success) {
  //         console.log(resp.data.otp);
  //         var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
  //         var originalText = bytes.toString(CryptoJS.enc.Utf8);
  //         console.log("CP Registration OTP", parseInt(originalText));
  //         setRecievedOtp(parseInt(originalText));
  //         // 900000 ;15 min
  //         const myTimeout = setTimeout(smsTimeOut, 900000);
  //       } else {
  //         if (resp.data.otp) {
  //           let bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
  //           let originalText = bytes.toString(CryptoJS.enc.Utf8);
  //           setRecievedOtp(parseInt(originalText));
  //           console.log("Add Lead OTP", parseInt(originalText));
  //         } else {
  //           // if (resp?.data?.error?.ErrorMessage) {
  //           //   errorTost(resp?.data?.error?.ErrorMessage);
  //           if (resp?.data?.error?.message) {
  //             errorTost(resp?.data?.error?.message);
  //           } else {
  //             errorTost("Something went wrong");
  //           }
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       console.log(err.message);
  //     });
  // }


  function smsApiCall() {
    setResendButton(false);
    setState((pre) => {
      pre.otp1 = "";
      pre.otp2 = "";
      pre.otp3 = "";
      pre.otp4 = "";
      return { ...pre };
    });
    setShowOtp(true);

    let body = {
      number: personDetail.phoneNumber,
      isInterNational: isInterNational,
      // email: personDetail.email ?? null,
    };

    sendOTPMessage(body)
      .then((resp) => {
        if (resp.data) {
          console.log("📦 Frontend received safeEncrypted:", resp.data.otp);

          // Check if SMS sending succeeded for non-international users
          if (!isInterNational && !resp.data.success) {
            errorTost("SMS sending failed. Please try again.");
            return;
          }

          // Step 1: Decode Base64 (as OTP is encoded)
          const encryptedBase64 = resp.data.otp;
          const encrypted = atob(encryptedBase64);
          console.log("🔒 Frontend ciphertext after atob:", encrypted);

          // Step 2: Decrypt with the same key
          var bytes = CryptoJS.AES.decrypt(encrypted, "hts secret key");
          var originalText = bytes.toString(CryptoJS.enc.Utf8);

          // If decryption fails
          if (!originalText) {
            console.error("Decryption failed! Key or ciphertext mismatch.");
            errorTost("OTP decryption failed, please try again.");
            return;
          }

          // Log the OTP and set it in the state
          console.log("Add Lead OTP", parseInt(originalText));
          setRecievedOtp(parseInt(originalText));

          // Set a 15-minute timeout to prevent resending OTP
          setTimeout(smsTimeOut, 900000);
        } else {
          // Handle case where OTP sending failed or data is missing
          if (resp?.data?.error?.ErrorMessage) {
            errorTost(resp?.data?.error?.ErrorMessage);
          } else {
            errorTost("Something went wrong");
          }
        }
      })
      .catch((err) => {
        console.error(err);
        errorTost("An error occurred while sending OTP.");
      });
  }

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return console.log("done");
    } else {
      return (
        <span>
          {" "}
          {zeroPad(minutes)}:{zeroPad(seconds)}
        </span>
      );
    }
  };


  //    const PAN_CardCheck = useRef(
  //   debounce((e, _apiToken) => {
  //     getPAN_cardDetails(e, _apiToken)
  //       .then((res) => {
  //         setIsLoadingPan(false);

  //         checkPanNumberExists(e)
  //           .then((PanNumberResp) => {
  //             if (PanNumberResp.length > 0) {
  //               setHelperText((pre) => ({
  //                 ...pre,
  //                 isPanValid: "Pan number already exists",
  //               }));
  //             } else {
  //               setHelperText((pre) => ({
  //                 ...pre,
  //                 isPanValid: "",
  //               }));

  //               if (res?.data?.message_code === "success") {
  //                 getGSTNumber(e)
  //                   .then((res) => {
  //                     const gstList = res.data.data.gstin_list;
  //                     setGstArray(gstList); // keep for UI if needed

  //                     if (gstList?.length > 0) {
  //                       const firstGst = gstList[0].gstin;

  //                       setFetchedGstFromPan(firstGst); // remember fetched GST
  //                       setCpDetails((pre) => ({
  //                         ...pre,
  //                         gstNumber: firstGst, // autofill in input

  //                       }));




  //                       setHelperText((pre) => ({
  //                         ...pre,
  //                         isGstNumber: "", // clear validation msg
  //                       }));



  //                     } else {
  //                       setFetchedGstFromPan(""); // no GST found
  //                       setCpDetails((pre) => ({
  //                         ...pre,
  //                         gstApplicable: false,
  //                         gstNumber: "",
  //                       }));
  //                     }
  //                   })
  //                   .catch((err) => {
  //                     setIsLoadingPan(false);
  //                     if (err.response?.data?.message === "No GSTIN Found.") {
  //                       setGstArray([]);
  //                       setCpDetails((pre) => ({
  //                         ...pre,
  //                         gstApplicable: false,
  //                         gstNumber: "",
  //                       }));
  //                     } else {
  //                       handleErrors(err, "FosRegistration -> getGSTNumber error");
  //                     }
  //                   });

  //                 setHelperText((pre) => ({
  //                   ...pre,
  //                   panVerified: true,
  //                   isPanValid: "",
  //                   isBillingName: "",
  //                   isPersonName: "",
  //                 }));

  //                 setPanCategory(res.data.data.category);

  //                 setCpDetails((prev) => ({
  //                   ...prev,
  //                   billingName: res.data.data.full_name,
  //                   panObject: res.data.data,
  //                 }));

  //                 setPersonDetail((prev) => ({
  //                   ...prev,
  //                   personaName: res.data.data.full_name,
  //                 }));

  //                 setBillingNameDisabled(true);
  //               }
  //             }
  //           })
  //           .catch((err) => {
  //             console.error("checkPanNumberExists", err);
  //           });
  //       })
  //       .catch((err) => {
  //         setIsLoadingPan(false);
  //         setCpDetails((prev) => ({
  //           ...prev,
  //           billingName: "",
  //         }));

  //         if (err?.response?.data?.message) {
  //           setHelperText((pre) => ({
  //             ...pre,
  //             isPanValid: err.response.data.message,
  //             panVerified: false,
  //           }));
  //         }

  //         setBillingNameDisabled(false);
  //       });
  //   }, 800)
  // ).current;



  const PAN_CardCheck = useRef(
    debounce((e, _apiToken) => {
      getPAN_cardDetails(e, _apiToken)
        .then((res) => {
          setIsLoadingPan(false);

          checkPanNumberExists(e)
            .then((PanNumberResp) => {
              if (PanNumberResp.length > 0) {
                setHelperText((pre) => ({
                  ...pre,
                  isPanValid: "Pan number already exists",
                }));
              } else {
                setHelperText((pre) => ({
                  ...pre,
                  isPanValid: "",
                }));

                if (res?.data?.message_code === "success") {
                  getGSTNumber(e)
                    .then((res) => {
                      const gstList = res.data.data.gstin_list;
                      setGstArray(gstList); // keep for UI if needed

                      if (gstList?.length > 0) {
                        // Filter only Active GST numbers
                        const activeGSTs = gstList.filter(
                          (gst) => gst.active_status?.toLowerCase() === "active"
                        );

                        if (activeGSTs.length === 1) {
                          // ✅ Auto-select if only one active GST
                          const firstGst = activeGSTs[0].gstin;

                          setFetchedGstFromPan(firstGst);
                          setCpDetails((pre) => ({
                            ...pre,
                            gstNumber: firstGst, // autofill
                          }));
                          setHelperText((pre) => ({
                            ...pre,
                            isGstNumber: "",
                          }));
                          setActiveGSTOptions([]); // clear dropdown options

                        } else if (activeGSTs.length > 1) {
                          // ✅ Multiple active GSTs → show dropdown
                          setActiveGSTOptions(activeGSTs.map((gst) => gst.gstin));

                          // Clear GST selection until user picks
                          setCpDetails((pre) => ({
                            ...pre,
                            gstNumber: "",
                          }));
                          setHelperText((pre) => ({
                            ...pre,
                            isGstNumber: "Please select GST Number from dropdown",
                          }));

                        } else {
                          // ❌ No active GST found
                          setFetchedGstFromPan("");
                          setCpDetails((pre) => ({
                            ...pre,
                            gstApplicable: false,
                            gstNumber: "",
                          }));
                          setActiveGSTOptions([]);
                        }

                      } else {
                        setFetchedGstFromPan("");
                        setCpDetails((pre) => ({
                          ...pre,
                          gstApplicable: false,
                          gstNumber: "",
                        }));
                        setActiveGSTOptions([]);
                      }
                    })
                    .catch((err) => {
                      setIsLoadingPan(false);
                      if (err.response?.data?.message === "No GSTIN Found.") {
                        setGstArray([]);
                        setCpDetails((pre) => ({
                          ...pre,
                          gstApplicable: false,
                          gstNumber: "",
                        }));
                        setActiveGSTOptions([]);
                      } else {
                        handleErrors(err, "FosRegistration -> getGSTNumber error");
                      }
                    });

                  setHelperText((pre) => ({
                    ...pre,
                    panVerified: true,
                    isPanValid: "",
                    isBillingName: "",
                    isPersonName: "",
                  }));

                  setPanCategory(res.data.data.category);

                  setCpDetails((prev) => ({
                    ...prev,
                    billingName: res.data.data.full_name,
                    panObject: res.data.data,
                  }));

                  setPersonDetail((prev) => ({
                    ...prev,
                    personaName: res.data.data.full_name,
                  }));

                  setBillingNameDisabled(true);
                }
              }
            })
            .catch((err) => {
              console.error("checkPanNumberExists", err);
            });
        })
        .catch((err) => {
          setIsLoadingPan(false);
          setCpDetails((prev) => ({
            ...prev,
            billingName: "",
          }));

          if (err?.response?.data?.message) {
            setHelperText((pre) => ({
              ...pre,
              isPanValid: err.response.data.message,
              panVerified: false,
            }));
          }

          setBillingNameDisabled(false);
        });
    }, 800)
  ).current;







  // const handleFirmDialogClose = () => {
  //   if (!cpDetails?.proprietorshipName?.trim()) {
  //     toast.error("Please enter and save a valid firm name before closing.");
  //     return;
  //   }
  //   setAskFirmNameDialog(false);
  // };

  // const handleFirmDialogConfirm = (firmName) => {
  //   const trimmedFirmName = firmName.trim();
  //   if (!trimmedFirmName) {
  //     toast.error("Firm name cannot be empty.");
  //     return;
  //   }

  //   setCpDetails((prev) => ({
  //     ...prev,
  //     proprietorshipName: trimmedFirmName,
  //     billingName: prev?.reraExtracted?.agentName || prev.billingName,
  //   }));

  //   setHelperText((pre) => ({
  //     ...pre,
  //     isBillingName: "",
  //   }));

  //   setAskFirmNameDialog(false);
  // };





  // const gstInfoApiCall = debounce((e) => {
  //   console.log(gstArray.filter(({ gstin }) => e === gstin));

  //   let result = gstArray.filter(({ gstin }) => e === gstin);
  //   console.log(result);

  //   setIsGSTLoading(true);

  //   if (result.length > 0) {
  //     getGSTInfo(e)
  //       .then((res) => {
  //         setIsGSTLoading(false);

  //         const gstData = res.data.data;
  //         const gstin = e;
  //         const extractedPANFromGST = gstin.substring(2, 12); // GSTIN chars 3–12 = PAN

  //         const panFromCp = cpDetails?.panObject?.pan_number;

  //         if (!panFromCp) {
  //           setHelperText((pre) => ({
  //             ...pre,
  //             isGstNumber: "PAN details missing. Please verify PAN first.",
  //             gstNumberVerified: false,
  //           }));
  //           errorTost("PAN not available. Please verify PAN first.");
  //           return;
  //         }

  //         if (extractedPANFromGST !== panFromCp) {
  //           setHelperText((pre) => ({
  //             ...pre,
  //             isGstNumber: "PAN and GST Number do not match.",
  //             gstNumberVerified: false,
  //           }));
  //           errorTost("PAN in GST doesn't match the provided PAN.");
  //           return;
  //         }

  //         // ✅ All good – proceed with GST verification
  //         setHelperText((pre) => ({
  //           ...pre,
  //           gstNumberVerified: true,
  //           isGstNumber: "",
  //         }));

  //         setCpDetails((pre) => ({
  //           ...pre,
  //           gstObject: gstData,
  //         }));

  //         console.log(gstData.business_name);

  //         if (gstData.business_name !== cpDetails.billingName) {
  //           setLedgerName(gstData.business_name);
  //           setMessage(
  //             "GST & PAN Name Not matched! Create Ledger using Proprietorship or Partnership."
  //           );
  //           // setOpenConfirmation(true);
  //         }
  //       })
  //       .catch((err) => {
  //         errorTost(err.message);
  //         console.log(err);
  //         setIsGSTLoading(false);
  //         setHelperText((pre) => ({
  //           ...pre,
  //           gstNumberVerified: false,
  //         }));
  //       });
  //   } else {
  //     setIsGSTLoading(false);
  //     setHelperText((pre) => ({
  //       ...pre,
  //       isGstNumber: "GST Number is not linked with PAN",
  //     }));
  //   }
  // }, 800);

  // const reraApiCall = debounce((e) => {

  //   console.log("rera api calll===========")
  //   console.log({ e });
  //   // if (panCategory === "person") {
  //   getReraDetails(e)
  //     .then((res) => {

  //       setCpDetails((prev) => {
  //         prev.reraObject = res.data.data;
  //         return { ...prev };
  //       });
  //       setHelperText((pre) => {
  //         pre.reraNumber = "reading rera doc...";
  //         return { ...pre };
  //       });
  //       readReraPdfFile(res.data.data.application_url)
  //         .then((resp) => {
  //           console.log(resp);
  //           // ??to find Rera type
  //           let responseObject = resp?.data?.pdf?.pages[0]?.texts.find(
  //             (data, index) => {
  //               if (index === 0) return false;
  //               return (
  //                 resp?.data?.pdf?.pages[0]?.texts[index - 1].text ==
  //                 "Information Type"
  //               );
  //             }
  //           )?.text;
  //           let responseObject2 = null;
  //           if (responseObject === undefined) {
  //             responseObject2 = resp?.data?.pdf?.pages[1]?.texts.find(
  //               (data, index) => {
  //                 if (index === 0) return false;
  //                 return (
  //                   resp?.data?.pdf?.pages[1]?.texts[index - 1]?.text ==
  //                   "Information Type"
  //                 );
  //               }
  //             )?.text;
  //           }
  //           console.log(responseObject);
  //           setIsReraLoading(false);
  //           setHelperText((pre) => {
  //             pre.reraVerified = true;
  //             pre.reraNumber = "";
  //             return { ...pre };
  //           });
  //           if (responseObject === "Other Than Individual" || responseObject2 === "Other Than Individual") {
  //             setCPType("Entity");
  //           } else {
  //             setCPType("Individual");
  //           }
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //           setIsReraLoading(false);
  //           setHelperText((pre) => {
  //             pre.reraVerified = false;
  //             pre.reraNumber = "";
  //             return { ...pre };
  //           });
  //         });
  //       // readingPdf(res.data.data.application_url).then((responseGet)=>{
  //       //   console.log({responseGet});
  //       // }).catch((err)=>{
  //       //   console.log(err);
  //       // })
  //       fetch(
  //         "https://corsanywhere-0o7d.onrender.com/" +
  //         res.data.data.application_url
  //       )
  //         .then((res) => {
  //           return res.arrayBuffer();
  //         })
  //         .then((res2) => {
  //           console.log("resp2", res2);
  //           const reraBase64 = window.btoa(
  //             [].slice
  //               .call(new Uint8Array(res2))
  //               .map(function (bin) {
  //                 return String.fromCharCode(bin);
  //               })
  //               .join("")
  //           );
  //           console.log("reraBase64", reraBase64);
  //           setCpDetails((pre) => {
  //             pre.reraDocument = reraBase64;
  //             return { ...pre };
  //           });
  //         })
  //         .catch((err) => {
  //           setIsReraLoading(false);
  //           errorTost(err.message);
  //           console.log(err);
  //         })
  //         .catch((err) => {
  //           setIsReraLoading(false);
  //           errorTost(err.message);
  //           console.log(err);
  //         });
  //       let agentName = res.data.data.agent_name.replace('Pvt Ltd', 'Private Limited');
  //       console.log({ agentName });
  //       if (
  //         cpDetails.billingName.toUpperCase() !==
  //         agentName.toUpperCase()
  //       ) {
  //         setReraPopUp(true);
  //         setLedgerName(agentName.toUpperCase());
  //         // !UnComment this for dev test otherwise dev can't register
  //         // !Changes on 21/03/2023,set alert message now
  //         setMessage(
  //           "RERA Name & PAN Name Not matched! Create Account as CP Individual"
  //         );
  //         setOpenConfirmation(true);

  //       }
  //     })
  //     .catch((err) => {
  //       setIsReraLoading(false);
  //       console.log(err);
  //       setHelperText((pre) => {
  //         pre.reraVerified = false;
  //         pre.reraNumber = err?.response?.data?.message;
  //         return { ...pre };
  //       });
  //     });
  //   // }
  // }, 800);



  // put this near your component top





  const skipFirmCloseValidationRef = useRef(false);

  const handleFirmDialogClose = () => {
    // if not coming from a successful submit, enforce validation
    if (!skipFirmCloseValidationRef.current && !cpDetails?.proprietorshipName?.trim()) {
      toast.error("Please enter and save a valid firm name before closing.");
      return;
    }

    // reset the flag and close
    skipFirmCloseValidationRef.current = false;
    setAskFirmNameDialog(false);
  };

  // const handleFirmDialogConfirm = (firmName) => {
  //   const trimmedFirmName = (firmName || "").trim();
  //   if (!trimmedFirmName) {
  //     toast.error("Firm name cannot be empty.");
  //     return;
  //   }

  //   setCpDetails((prev) => ({
  //     ...prev,
  //     proprietorshipName: trimmedFirmName,
  //     billingName: prev?.reraExtracted?.agentName || prev.billingName,
  //   }));

  //   setHelperText((pre) => ({
  //     ...pre,
  //     isBillingName: "",
  //   }));

  //   // mark that we're closing due to a successful submit
  //   skipFirmCloseValidationRef.current = true;

  //   // now close without triggering the close-error
  //   setAskFirmNameDialog(false);
  // };




  const handleFirmDialogConfirm = ({ firmName, shopActFile }) => {
    const trimmedFirmName = (firmName || "").trim();
    if (!trimmedFirmName) {
      toast.error("Firm name cannot be empty.");
      return;
    }

    // Save firm name into cpDetails
    setCpDetails((prev) => ({
      ...prev,
      proprietorshipName: trimmedFirmName,
      billingName: prev?.reraExtracted?.agentName || prev.billingName,
      // ⚠️ DO NOT set shopActUrl here — it will be generated after upload with cpId
    }));

    // Store the actual file so validateBankDetails can upload it later
    setShopActFile(shopActFile);

    setHelperText((pre) => ({
      ...pre,
      isBillingName: "",
    }));

    skipFirmCloseValidationRef.current = true;
    setAskFirmNameDialog(false);
  };




  const gstInfoApiCall = debounce((e) => {
    console.log(gstArray.filter(({ gstin }) => e === gstin));

    let result = gstArray.filter(({ gstin }) => e === gstin);
    console.log(result);

    setIsGSTLoading(true);

    if (result.length > 0) {
      getGSTInfo(e)
        .then((res) => {
          setIsGSTLoading(false);

          const gstData = res.data.data;
          const gstin = e;
          const extractedPANFromGST = gstin.substring(2, 12); // GSTIN chars 3–12 = PAN

          const panFromCp = cpDetails?.panObject?.pan_number;

          if (!panFromCp) {
            setHelperText((pre) => ({
              ...pre,
              isGstNumber: "PAN details missing. Please verify PAN first.",
              gstNumberVerified: false,
            }));
            errorTost("PAN not available. Please verify PAN first.");
            return;
          }

          if (extractedPANFromGST !== panFromCp) {
            setHelperText((pre) => ({
              ...pre,
              isGstNumber: "PAN and GST Number do not match.",
              gstNumberVerified: false,
            }));
            errorTost("PAN in GST doesn't match the provided PAN.");
            return;
          }

          // ✅ All good – proceed with GST verification
          setHelperText((pre) => ({
            ...pre,
            gstNumberVerified: true,
            isGstNumber: "",
          }));

          // --- NEW: Store constitution_of_business as Proprietorship Name ---
          const constitutionName = gstData.constitution_of_business;
          if (constitutionName) {
            setCpDetails((pre) => ({
              ...pre,
              proprietorshipName: constitutionName, // GST constitution_of_business
              gstObject: gstData,
              billingName: pre?.reraExtracted?.agentName || pre.billingName,
            }));
            console.log("proproterrrrr", cpDetails)
          } else {
            setCpDetails((pre) => ({
              ...pre,
              gstObject: gstData,
            }));
          }
          // --- END NEW ---

          console.log(gstData.business_name);

          if (gstData.business_name !== cpDetails.billingName) {
            setLedgerName(gstData.business_name);
            setMessage(
              "GST & PAN Name Not matched! Create Ledger using Proprietorship or Partnership."
            );
            // setOpenConfirmation(true);
          }
        })
        .catch((err) => {
          errorTost(err.message);
          console.log(err);
          setIsGSTLoading(false);
          setHelperText((pre) => ({
            ...pre,
            gstNumberVerified: false,
          }));
        });
    } else {
      setIsGSTLoading(false);
      setHelperText((pre) => ({
        ...pre,
        isGstNumber: "GST Number is not linked with PAN",
      }));
    }
  }, 800);






  function wordsMatch(name1, name2) {
    const a = name1?.split(" ") || [];
    const b = name2?.split(" ") || [];
    const common = a.filter((word) => b.includes(word));
    return common.length >= 2;
  }



  // const reraApiCall = debounce((e) => {
  //   console.log("🔍 Starting RERA API Call for:", e);

  //   getReraDetails(e)
  //     .then((res) => {
  //       const details = res.data.data.details[0];
  //       const certificateUrl = details?.certificate_url;
  //       const applicationUrl = details?.application_url;

  //       console.log("📄 Certificate URL:", certificateUrl);
  //       console.log("📄 Application URL:", applicationUrl);

  //       setCpDetails((prev) => {
  //         prev.reraObject = res.data.data;
  //         return { ...prev };
  //       });

  //       setHelperText((pre) => {
  //         pre.reraNumber = "reading rera doc...";
  //         return { ...pre };
  //       });

  //       const extractDatesFromCertificate = async (url) => {
  //         try {
  //           const resp = await readReraPdfFile(url);
  //           for (const page of resp?.data?.pdf?.pages || []) {
  //             const pageText = page.texts.map((t) => t.text).join(" ").replace(/\s+/g, ' ').trim();
  //             const match = pageText.match(/commencing from\s+(\d{2}\/\d{2}\/\d{4})\s+and ending with\s+(\d{2}\/\d{2}\/\d{4})/i);
  //             if (match) {
  //               const toTimestamp = (d) => {
  //                 const [dd, mm, yyyy] = d.split("/");
  //                 return new Date(`${yyyy}-${mm}-${dd}`).getTime();
  //               };
  //               return {
  //                 startDate: toTimestamp(match[1]),
  //                 endDate: toTimestamp(match[2]),
  //               };
  //             }
  //           }
  //         } catch (err) {
  //           console.error("❌ Error reading certificate for dates:", err);
  //         }
  //         return { startDate: null, endDate: null };
  //       };

  //       const extractAgentData = async (url, isFallback = false) => {
  //         try {
  //           const resp = await readReraPdfFile(url);
  //           const findTextNearHint = (resp, hint) => {
  //             for (const page of resp?.data?.pdf?.pages) {
  //               const found = page?.texts.find((_, idx) => {
  //                 if (idx === 0) return false;
  //                 return page.texts[idx - 1].text.trim().toLowerCase() === hint.toLowerCase();
  //               });
  //               if (found) return found.text.trim();
  //             }
  //             return null;
  //           };

  //           let agentName =
  //             findTextNearHint(resp, "Name of Agent:") ||
  //             findTextNearHint(resp, "Name of Agent") ||
  //             null;

  //           let typeOfAgent =
  //             findTextNearHint(resp, "Type of Agent:") ||
  //             findTextNearHint(resp, "Type of Agent") ||
  //             null;

  //           if (isFallback && (!typeOfAgent || typeOfAgent === "")) {
  //             const infoType = resp?.data?.pdf?.pages[0]?.texts.find((t, i, arr) =>
  //               arr[i - 1]?.text === "Information Type"
  //             )?.text;

  //             if (infoType === "Other Than Individual") typeOfAgent = "Other Than Individual";
  //             else typeOfAgent = "Individual";
  //           }

  //           const cpType = typeOfAgent && typeOfAgent !== "Individual" ? "Entity" : "Individual";

  //           return { agentName, typeOfAgent, cpType };
  //         } catch (err) {
  //           console.error(`❌ Error reading ${isFallback ? "application URL" : "certificate URL"}:`, err);
  //           return { agentName: null, typeOfAgent: null, cpType: "Individual" };
  //         }
  //       };

  //       const handleExtraction = async () => {
  //         if (!certificateUrl) {
  //           console.error("❌ No certificate URL provided.");
  //           return;
  //         }

  //         const { startDate, endDate } = await extractDatesFromCertificate(certificateUrl);

  //         if (!startDate || !endDate) {
  //           setIsReraLoading(false);
  //           setHelperText((pre) => ({
  //             ...pre,
  //             reraVerified: false,
  //             reraNumber: "Start/End date missing in certificate.",
  //           }));
  //           return;
  //         }

  //         let { agentName, typeOfAgent, cpType } = await extractAgentData(certificateUrl);

  //         if ((!agentName || !typeOfAgent) && applicationUrl) {
  //           const fallback = await extractAgentData(applicationUrl, true);
  //           if (!agentName) agentName = fallback.agentName;
  //           if (!typeOfAgent) typeOfAgent = fallback.typeOfAgent;
  //           if (!cpType) cpType = fallback.cpType;
  //         }

  //         setReraStartDate(startDate);
  //         setReraEndDate(endDate);
  //         setAgentType(typeOfAgent);


  //         setCpDetails((prev) => ({
  //           ...prev,
  //           reraExtracted: {
  //             agentName,
  //             typeOfAgent,
  //             startDate,
  //             endDate,
  //             cpType,
  //           },
  //         }));
  //           console.log("reratypeofagent",typeOfAgent);
  //           console.log("cptypeeeee",cpType);

  //         setIsReraLoading(false);
  //         setHelperText((pre) => ({
  //           ...pre,
  //           reraNumber: "",
  //           reraVerified: true,
  //         }));

  //         const normalizeName = (name) =>
  //           name
  //             ?.replace(/PVT\.?\s*LTD\.?/gi, "PRIVATE LIMITED")
  //             ?.replace(/[.,]/g, "")
  //             ?.replace(/\s+/g, " ")
  //             ?.trim()
  //             ?.toUpperCase();

  //         const gstin = cpDetails?.gstNumber?.trim();
  //         const isMaharashtraGST = gstin?.startsWith("27") && cpDetails?.gstApplicable;

  //         const agentNameRERA = normalizeName(details?.agent_name);
  //         const gstBusinessName = normalizeName(cpDetails?.gstObject?.business_name);
  //         const gstLegalName = normalizeName(cpDetails?.gstObject?.legal_name);
  //         const panName = normalizeName(cpDetails?.panObject?.full_name);

  //         console.log("📤 Normalized Names:");
  //         console.log("🔹 RERA Agent Name:", agentNameRERA);
  //         console.log("🔹 GST Business Name:", gstBusinessName);
  //         console.log("🔹 GST Legal Name:", gstLegalName);
  //         console.log("🔹 PAN Name:", panName);

  //         if (isMaharashtraGST) {
  //           if (
  //             agentNameRERA &&
  //             (wordsMatch(agentNameRERA, gstBusinessName) ||
  //              wordsMatch(agentNameRERA, gstLegalName))
  //           ) {
  //             setCpDetails((prev) => ({
  //               ...prev,
  //               billingName: agentNameRERA,
  //             }));
  //             setHelperText((pre) => ({
  //               ...pre,
  //               isBillingName: "",
  //             }));
  //           } else {
  //             console.warn("⚠️ GST Name mismatch — showing RERA popup.");
  //             setReraPopUp(true);
  //             setLedgerName(agentNameRERA);
  //             setMessage("RERA Name does not match GST Business/Legal Name! Please verify or create as CP Individual.");
  //             setHelperText((pre) => ({
  //               ...pre,
  //               isBillingName: "Mismatch: RERA Name ≠ GST Business/Legal Name",
  //             }));
  //           }
  //         } else {
  //           // ✅ GST NOT APPLICABLE FLOW
  //           if (
  //             panName &&
  //             agentNameRERA &&
  //             (panName === agentNameRERA ||
  //               agentNameRERA.includes(panName) ||
  //               panName.includes(agentNameRERA))
  //           ) {
  //             setCpDetails((prev) => ({
  //               ...prev,
  //               billingName: agentNameRERA,
  //             }));
  //             setHelperText((pre) => ({
  //               ...pre,
  //               isBillingName: "",
  //             }));
  //           } else {
  //             console.warn("⚠️ PAN Name mismatch — asking for firm name.");

  //             setCpDetails((prev) => ({
  //               ...prev,
  //               billingName: agentNameRERA, // ✅ Always set billing name to RERA
  //             }));

  //             setLedgerName(agentNameRERA);
  //             setMessage("PAN Name does not match RERA Name! Please enter your Proprietorship/Firm Name.");

  //             setHelperText((pre) => ({
  //               ...pre,
  //               isBillingName: "",
  //             }));

  //             setAskFirmNameDialog(true);
  //           }
  //         }
  //       };

  //       handleExtraction();
  //     })
  //     .catch((err) => {
  //       console.error("❌ RERA fetch failed:", err);
  //       setIsReraLoading(false);
  //       setHelperText((pre) => ({
  //         ...pre,
  //         reraVerified: false,
  //         reraNumber: err?.response?.data?.message || "RERA fetch failed",
  //       }));
  //     });
  // }, 800);





  const reraApiCall = debounce((e) => {
    console.log("🔍 Starting RERA API Call for:", e);

    getReraDetails(e)
      .then((res) => {
        const details = res.data.data.details[0];
        const certificateUrl = details?.certificate_url;
        const applicationUrl = details?.application_url;

        console.log("📄 Certificate URL:", certificateUrl);
        console.log("📄 Application URL:", applicationUrl);

        setCpDetails((prev) => {
          prev.reraObject = res.data.data;
          return { ...prev };
        });

        setHelperText((pre) => {
          pre.reraNumber = "reading rera doc...";
          return { ...pre };
        });

        // 📌 Extract from Certificate (updated)
        // const extractFromCertificate = async (url) => {
        //   let startDate = null;
        //   let endDate = null;
        //   let typeOfAgent = "";
        //   let cpType = "";

        //   try {
        //     const resp = await readReraPdfFile(url);
        //     for (const page of resp?.data?.pdf?.pages || []) {
        //       const pageText = page.texts
        //         .map((t) => t.text)
        //         .join(" ")
        //         .replace(/\s+/g, " ")
        //         .trim();

        //       // Dates
        //       const match = pageText.match(
        //         /commencing from\s+(\d{2}\/\d{2}\/\d{4})\s+and ending with\s+(\d{2}\/\d{2}\/\d{4})/i
        //       );
        //       if (match) {
        //         const toTimestamp = (d) => {
        //           const [dd, mm, yyyy] = d.split("/");
        //           return new Date(`${yyyy}-${mm}-${dd}`).getTime();
        //         };
        //         startDate = toTimestamp(match[1]);
        //         endDate = toTimestamp(match[2]);
        //       }

        //       // Type of Agent
        //       const typeMatch = pageText.match(/type of agent\s*:\s*(.+?)(?:\s|$)/i);
        //       if (typeMatch) {
        //         typeOfAgent = typeMatch[1].trim();
        //       }

        //       // cpType from typeOfAgent
        //       if (typeOfAgent) {
        //         if (/individual/i.test(typeOfAgent)) {
        //           cpType = "Individual";
        //         } else {
        //           cpType = "Entity";
        //         }
        //       } else {
        //         // Fallback detection from text
        //         if (/individual/i.test(pageText)) {
        //           cpType = "Individual";
        //         } else if (/partnership|company|firm|entity/i.test(pageText)) {
        //           cpType = "Entity";
        //         }
        //       }
        //     }
        //   } catch (err) {
        //     console.error("❌ Error reading certificate:", err);
        //   }

        //   console.log("📄 Extracted from Certificate:", { startDate, endDate, typeOfAgent, cpType });
        //   return { startDate, endDate, typeOfAgent, cpType };
        // };


        const extractFromCertificate = async (url) => {
          let startDate = null;
          let endDate = null;
          let typeOfAgent = "";
          let cpType = "";

          try {
            const resp = await readReraPdfFile(url);
            const pages = resp?.data?.pdf?.pages || [];

            for (const page of pages) {
              const pageText = page.texts
                .map((t) => t.text)
                .join(" ")
                .replace(/\s+/g, " ")
                .trim();

              // 📅 Dates
              const match = pageText.match(
                /commencing from\s+(\d{2}\/\d{2}\/\d{4})\s+and ending with\s+(\d{2}\/\d{2}\/\d{4})/i
              );
              if (match) {
                const toTimestamp = (d) => {
                  const [dd, mm, yyyy] = d.split("/");
                  return new Date(`${yyyy}-${mm}-${dd}`).getTime();
                };
                startDate = toTimestamp(match[1]);
                endDate = toTimestamp(match[2]);
              }

              // 👤 Type of Agent
              const typeMatch = pageText.match(/type of agent\s*:\s*(.+?)(?:\s|$)/i);
              if (typeMatch) {
                typeOfAgent = typeMatch[1].trim();
              }

              // 🧾 cpType based on typeOfAgent or fallback from full text
              if (typeOfAgent) {
                cpType = /individual/i.test(typeOfAgent) ? "Individual" : "Entity";
              } else if (/individual/i.test(pageText)) {
                cpType = "Individual";
              } else if (/partnership|company|firm|entity/i.test(pageText)) {
                cpType = "Entity";
              }
            }

            // ⚠️ Check if PDF is empty or didn't extract key values
            if (!startDate || !endDate) {
              console.warn("❌ Certificate dates missing. Triggering upload fallback.");
              setIsReraLoading(false);
              setHelperText((pre) => ({
                ...pre,
                reraVerified: false,
                reraNumber: "Dates missing in RERA certificate. Please upload manually.",
              }));
              setShowReraUploadDialog(true); // ⬅️ trigger fallback upload
              return { startDate: null, endDate: null, typeOfAgent: "", cpType: "" };
            }

          } catch (err) {
            console.error("❌ Error reading certificate:", err);
            setIsReraLoading(false);
            setHelperText((pre) => ({
              ...pre,
              reraVerified: false,
              reraNumber: "Error reading certificate. Please upload manually.",
            }));
            setShowReraUploadDialog(true); // ⬅️ trigger fallback upload
            return { startDate: null, endDate: null, typeOfAgent: "", cpType: "" };
          }

          console.log("📄 Extracted from Certificate:", { startDate, endDate, typeOfAgent, cpType });
          return { startDate, endDate, typeOfAgent, cpType };
        };

        // 📌 Extract cpType from Application (updated)
        const extractCpTypeFromApplication = async (url) => {
          let detectedType = "Individual";
          try {
            const resp = await readReraPdfFile(url);
            const text = (resp?.data?.pdf?.pages || [])
              .map((p) => p.texts.map((t) => t.text).join(" "))
              .join(" ")
              .replace(/\s+/g, " ")
              .trim()
              .toLowerCase();

            console.log("📄 Application PDF text (first 200 chars):", text.slice(0, 200));

            if (text.includes("other than individual")) {
              detectedType = "Entity";
            } else if (text.includes("individual")) {
              detectedType = "Individual";
            }
          } catch (err) {
            console.error("❌ Error reading application PDF:", err);
          }

          console.log("✅ Detected CP Type from Application:", detectedType);
          return detectedType;
        };

        const handleExtraction = async () => {
          if (!certificateUrl) {
            console.error("❌ No certificate URL provided.");
            return;
          }

          // Step 1 → Certificate
          let { startDate, endDate, typeOfAgent, cpType } = await extractFromCertificate(certificateUrl);

          // if (!startDate || !endDate) {
          //   setIsReraLoading(false);
          //   setHelperText((pre) => ({
          //     ...pre,
          //     reraVerified: false,
          //     reraNumber: "Start/End date missing in certificate.",
          //   }));
          //   return;
          // }


          if (!startDate || !endDate) {
            setIsReraLoading(false);
            setHelperText((pre) => ({
              ...pre,
              reraVerified: false,
              reraNumber: "Start/End date missing in certificate. Please upload your PDF.",
            }));
            setShowUpload(true);
            return;
          }


          // Step 2 → If cpType missing, fallback to Application
          if (!cpType && applicationUrl) {
            cpType = await extractCpTypeFromApplication(applicationUrl);
          }

          // Step 3 → Save extracted RERA info
          setReraStartDate(startDate);
          setReraEndDate(endDate);

          setCpDetails((prev) => ({
            ...prev,
            reraExtracted: {
              agentName: details?.agent_name,
              typeOfAgent: typeOfAgent || "",
              startDate,
              endDate,
              cpType: cpType || "Individual",
            },
            cpType: cpType || "Individual",
          }));

          console.log("reratypeofagent", typeOfAgent);
          console.log("cptypeeeee", cpType);

          setIsReraLoading(false);
          setHelperText((pre) => ({
            ...pre,
            reraNumber: "",
            reraVerified: true,
          }));

          const normalizeName = (name) =>
            name
              ?.replace(/PVT\.?\s*LTD\.?/gi, "PRIVATE LIMITED")
              ?.replace(/[.,]/g, "")
              ?.replace(/\s+/g, " ")
              ?.trim()
              ?.toUpperCase();

          const gstin = cpDetails?.gstNumber?.trim();
          const isMaharashtraGST = gstin?.startsWith("27") && cpDetails?.gstApplicable;

          const agentNameRERA = normalizeName(details?.agent_name);
          const gstBusinessName = normalizeName(cpDetails?.gstObject?.business_name);
          const gstLegalName = normalizeName(cpDetails?.gstObject?.legal_name);
          const panName = normalizeName(cpDetails?.panObject?.full_name);

          console.log("📤 Normalized Names:");
          console.log("🔹 RERA Agent Name:", agentNameRERA);
          console.log("🔹 GST Business Name:", gstBusinessName);
          console.log("🔹 GST Legal Name:", gstLegalName);
          console.log("🔹 PAN Name:", panName);

          if (isMaharashtraGST) {
            if (
              agentNameRERA &&
              (wordsMatch(agentNameRERA, gstBusinessName) ||
                wordsMatch(agentNameRERA, gstLegalName))
            ) {
              setCpDetails((prev) => ({
                ...prev,
                billingName: agentNameRERA,
              }));
              setHelperText((pre) => ({
                ...pre,
                isBillingName: "",
              }));
            } else {
              console.warn("⚠️ GST Name mismatch — showing RERA popup.");
              setReraPopUp(true);
              setLedgerName(agentNameRERA);
              setMessage(
                "RERA Name does not match GST Business/Legal Name! Please verify or create as CP Individual."
              );
              setHelperText((pre) => ({
                ...pre,
                isBillingName: "Mismatch: RERA Name ≠ GST Business/Legal Name",
              }));
            }
          }





          // else {
          //   if (
          //     panName &&
          //     agentNameRERA &&
          //     (panName === agentNameRERA ||
          //       agentNameRERA.includes(panName) ||
          //       panName.includes(agentNameRERA))
          //   ) {
          //     setCpDetails((prev) => ({
          //       ...prev,
          //       billingName: agentNameRERA,
          //     }));
          //     setHelperText((pre) => ({
          //       ...pre,
          //       isBillingName: "",
          //     }));
          //   } else {
          //     console.warn("⚠️ PAN Name mismatch — asking for firm name.");

          //     setCpDetails((prev) => ({
          //       ...prev,
          //       billingName: agentNameRERA, // ✅ Always set billing name to RERA
          //     }));

          //     setLedgerName(agentNameRERA);
          //     setMessage(
          //       "PAN Name does not match RERA Name! Please enter your Proprietorship/Firm Name."
          //     );

          //     setHelperText((pre) => ({
          //       ...pre,
          //       isBillingName: "",
          //     }));

          //     setAskFirmNameDialog(true);
          //   }
          // }


          else {
            if (
              panName &&
              agentNameRERA &&
              (panName === agentNameRERA ||
                agentNameRERA.includes(panName) ||
                panName.includes(agentNameRERA))
            ) {
              // ✅ Exact or partial match
              setCpDetails((prev) => ({
                ...prev,
                billingName: agentNameRERA,
              }));
              setHelperText((pre) => ({
                ...pre,
                isBillingName: "",
              }));
            } else {
              console.warn("⚠️ PAN Name mismatch — checking proprietorship option.");

              // 🆕 Step 2a: If GST is NOT applicable → Ask proprietorship first
              if (!cpDetails?.gstApplicable) {
                setLedgerName(agentNameRERA);
                setMessage(
                  "RERA Name does not fully match PAN Name. Is this a Proprietorship?"
                );
                setShowProprietorshipDialog(true); // <-- Opens Yes/No dialog
                return; // Stop further execution until user responds
              }

              // Step 2b: Original mismatch logic (for GST applicable)
              setCpDetails((prev) => ({
                ...prev,
                billingName: agentNameRERA,
              }));
              setLedgerName(agentNameRERA);
              setMessage(
                "PAN Name does not match RERA Name! Please enter your Proprietorship/Firm Name."
              );
              setHelperText((pre) => ({
                ...pre,
                isBillingName: "",
              }));
              setAskFirmNameDialog(true);
            }
          }

        };

        handleExtraction();
      })
      .catch((err) => {
        console.error("❌ RERA fetch failed:", err);
        setIsReraLoading(false);
        setHelperText((pre) => ({
          ...pre,
          reraVerified: false,
          reraNumber: err?.response?.data?.message || "RERA fetch failed",
        }));
      })
      .finally(() => {
        setIsReraLoading(false); // ✅ always stop loader here
      });
  }, 800);








  const debouncedBankDetailsCall = debounce((e) => {
    checkBankDetails(bankDetails.accountNumber, bankDetails.ifscCode);
  }, 800);

  // function checkBankDetails(accountNo, IFSC_Code) {
  //   setIsLoadingIfSC(true);
  //   setIsLoadingAccount(true);
  //   console.log(accountNo, IFSC_Code);
  //   let postBody = {
  //     id_number: accountNo,
  //     ifsc: IFSC_Code,
  //   };
  //   getAccountDetails(postBody)
  //     .then((res) => {
  //       setIsLoadingIfSC(false);
  //       setIsLoadingAccount(false);
  //       console.log(res?.data?.data);
  //       if (res?.data?.data?.account_exists) {
  //         setHelperText((pre) => {
  //           pre.isAccountNumber = "";
  //           pre.isHolderName = "";
  //           pre.isIfscCode = "";
  //           pre.bankDetailsIsVerified = true;
  //           return { ...pre };
  //         });
  //         setBankDetails((pre) => {
  //           pre.holderName = res.data.data.full_name;
  //           return { ...pre };
  //         });
  //         // let arrayBillingName= cpDetails.billingName.split(' ');
  //         // let accountHolderName=res.data.data.full_name.split(' ');
  //         if (cpDetails.billingName.includes(res.data.data.full_name)) {
  //           setHelperText((pre) => {
  //             pre.isHolderName = "";
  //             pre.bankDetailsIsVerified = true;
  //             return { ...pre };
  //           });
  //         } else {
  //           // !Remove This function before prod
  //           setHelperText((pre) => {
  //             pre.isHolderName = "";
  //             pre.bankDetailsIsVerified = true;
  //             return { ...pre };
  //           });
  //           // !Uncomment this function before prod
  //           // setHelperText((pre) => {
  //           //   pre.isHolderName =
  //           //     "Account holder name and Billing name doesn't match";
  //           //   pre.bankDetailsIsVerified = false;
  //           //   return { ...pre };
  //           // });
  //         }
  //         console.log("if");
  //       } else {
  //         console.log("else");
  //         setHelperText((pre) => {
  //           pre.isAccountNumber = "Something went wrong";
  //           pre.isIfscCode = "Something went wrong";
  //           pre.bankDetailsIsVerified = false;
  //           return { ...pre };
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       setIsLoadingIfSC(false);
  //       setIsLoadingAccount(false);
  //       console.log(err);
  //       // console.log(err.response.data);

  //       // errorToast(err.response.data.message_code);
  //       setHelperText((pre) => {
  //         pre.isAccountNumber = err?.response?.data?.message_code;
  //         // pre.isIfscCode = err?.response?.data?.message_code;
  //         pre.bankDetailsIsVerified = false;
  //         return { ...pre };
  //       });
  //       if (err?.response?.data?.message_code.includes("invalid_ifsc")) {
  //         setHelperText((pre) => {
  //           pre.isAccountNumber = "";
  //           pre.isIfscCode = err?.response?.data?.message_code;
  //           pre.bankDetailsIsVerified = false;
  //           return { ...pre };
  //         });
  //       }
  //       //! Error Toast
  //       //* err.response.data.message_code
  //     });
  // }



  // function checkBankDetails(accountNo, IFSC_Code) {
  //   setIsLoadingIfSC(true);
  //   setIsLoadingAccount(true);
  //   console.log(accountNo, IFSC_Code);

  //   const postBody = {
  //     id_number: accountNo,
  //     ifsc: IFSC_Code,
  //   };

  //   getAccountDetails(postBody)
  //     .then((res) => {
  //       setIsLoadingIfSC(false);
  //       setIsLoadingAccount(false);

  //       const accountExists = res?.data?.data?.account_exists;
  //       const holderName = res?.data?.data?.full_name?.toUpperCase()?.trim();

  //       if (accountExists && holderName) {
  //         const reraAgentName = cpDetails?.reraExtracted?.agentName?.toUpperCase()?.trim() || "";
  //         const proprietorshipName = cpDetails?.proprietorshipName?.toUpperCase()?.trim() || "";

  //         const matchesRera = reraAgentName && holderName === reraAgentName;
  //         const matchesProp = proprietorshipName && holderName === proprietorshipName;

  //         const isValidName = matchesRera || matchesProp;

  //         setHelperText((pre) => ({
  //           ...pre,
  //           isAccountNumber: "",
  //           isIfscCode: "",
  //           isHolderName: isValidName ? "" : "Account holder name does not match RERA or Proprietorship name.",
  //           bankDetailsIsVerified: isValidName,
  //         }));

  //         setBankDetails((pre) => ({
  //           ...pre,
  //           holderName: holderName, // populate read-only input
  //         }));

  //       } else {
  //         setHelperText((pre) => ({
  //           ...pre,
  //           isAccountNumber: "Something went wrong",
  //           isIfscCode: "Something went wrong",
  //           bankDetailsIsVerified: false,
  //         }));
  //       }
  //     })
  //     .catch((err) => {
  //       setIsLoadingIfSC(false);
  //       setIsLoadingAccount(false);
  //       console.log(err);

  //       const msg = err?.response?.data?.message_code || "Something went wrong";

  //       if (msg.includes("invalid_ifsc")) {
  //         setHelperText((pre) => ({
  //           ...pre,
  //           isAccountNumber: "",
  //           isIfscCode: msg,
  //           bankDetailsIsVerified: false,
  //         }));
  //       } else {
  //         setHelperText((pre) => ({
  //           ...pre,
  //           isAccountNumber: msg,
  //           isIfscCode: "",
  //           bankDetailsIsVerified: false,
  //         }));
  //       }
  //     });
  // }

  function normalizeName(name) {
    return name
      ?.replace(/PVT\.?\s*LTD\.?/gi, "PRIVATE LIMITED")
      ?.replace(/[.,]/g, "")
      ?.replace(/\s+/g, " ")
      ?.trim()
      ?.toUpperCase();
  }

  function wordsMatch(name1, name2) {
    const a = name1?.split(" ") || [];
    const b = name2?.split(" ") || [];
    const common = a.filter((word) => b.includes(word));
    return common.length >= 2; // tweak threshold if needed
  }
















  // function checkBankDetails(accountNo, IFSC_Code, firmNameFromDialog = null) {
  //   setIsLoadingIfSC(true);
  //   setIsLoadingAccount(true);

  //   const postBody = {
  //     id_number: accountNo,
  //     ifsc: IFSC_Code,
  //   };

  //   getAccountDetails(postBody)
  //     .then((res) => {
  //       setIsLoadingIfSC(false);
  //       setIsLoadingAccount(false);

  //       if (res?.data?.data?.account_exists) {
  //         const holderName = res.data.data.full_name;
  //         const holderNameNormalized = normalizeName(holderName);

  //         const gstBusinessName = normalizeName(cpDetails?.gstObject?.business_name);
  //         const reraAgentName = normalizeName(
  //           cpDetails?.reraExtracted?.agentName || cpDetails?.reraObject?.details?.[0]?.agent_name
  //         );
  //         const proprietorshipName = normalizeName(cpDetails?.proprietorshipName);
  //         const enteredFirmName = firmNameFromDialog ? normalizeName(firmNameFromDialog) : null;

  //         console.log("🔍 Normalized Holder Name:", holderNameNormalized);
  //         console.log("🔍 GST Business Name:", gstBusinessName);
  //         console.log("🔍 RERA Agent Name:", reraAgentName);
  //         console.log("🔍 Proprietorship Name:", proprietorshipName);
  //         console.log("🔍 Entered Firm Name:", enteredFirmName);

  //         let isValid = false;

  //         if (cpDetails?.gstApplicable === true) {
  //           // ✅ GST applicable — ONLY match with GST or RERA
  //           const matchesGST =
  //             gstBusinessName &&
  //             partialWordsMatch(holderNameNormalized, gstBusinessName);

  //           const matchesRERA =
  //             reraAgentName &&
  //             partialWordsMatch(holderNameNormalized, reraAgentName);

  //           isValid = matchesGST || matchesRERA;
  //         } else {
  //           // ✅ GST not applicable — match with RERA or Proprietorship (or entered firm name if asked)
  //           const matchesRera =
  //             reraAgentName &&
  //             partialWordsMatch(holderNameNormalized, reraAgentName);

  //           let matchesProp = false;
  //           let matchesEnteredFirm = false;

  //           if (!matchesRera) {
  //             if (proprietorshipName) {
  //               matchesProp = partialWordsMatch(holderNameNormalized, proprietorshipName);
  //             } else if (enteredFirmName) {
  //               matchesEnteredFirm = partialWordsMatch(holderNameNormalized, enteredFirmName);
  //             } else {
  //               // ⚠ No proprietorship name and no entered firm name — ask for it
  //               setIsLoadingIfSC(false);
  //               setIsLoadingAccount(false);
  //               setHelperText((pre) => ({
  //                 ...pre,
  //                 isHolderName: "",
  //                 isAccountNumber: "",
  //                 isIfscCode: "",
  //                 bankDetailsIsVerified: false,
  //               }));
  //               setAskFirmNameDialog(true);
  //               return;
  //             }
  //           }

  //           isValid = matchesRera || matchesProp || matchesEnteredFirm;
  //         }

  //         // Save bank holder name
  //         setBankDetails((pre) => ({
  //           ...pre,
  //           holderName: res.data.data.full_name,
  //         }));

  //         if (isValid) {
  //           console.log("✅ Bank holder name matched successfully");
  //           setHelperText((pre) => ({
  //             ...pre,
  //             isHolderName: "",
  //             isAccountNumber: "",
  //             isIfscCode: "",
  //             bankDetailsIsVerified: true,
  //           }));
  //         } else {
  //           console.log("❌ Bank holder name did not match");
  //           setHelperText((pre) => ({
  //             ...pre,
  //             isHolderName: cpDetails?.gstApplicable
  //               ? "Account holder name doesn't partially match GST Business Name or RERA Name."
  //               : "Account holder name doesn't partially match RERA, Proprietorship Name, or Entered Firm Name.",

  //             isAccountNumber: "",
  //             isIfscCode: "",
  //             bankDetailsIsVerified: false,
  //           }));
  //         }
  //       } else {
  //         setHelperText((pre) => ({
  //           ...pre,
  //           isAccountNumber: "Something went wrong",
  //           isIfscCode: "Something went wrong",
  //           bankDetailsIsVerified: false,
  //         }));
  //       }
  //     })
  //     .catch((err) => {
  //       setIsLoadingIfSC(false);
  //       setIsLoadingAccount(false);
  //       console.error("Error:", err);

  //       const errorCode = err?.response?.data?.message_code || "Verification failed";

  //       setHelperText((pre) => ({
  //         ...pre,
  //         isAccountNumber: errorCode.includes("invalid_ifsc") ? "" : errorCode,
  //         isIfscCode: errorCode.includes("invalid_ifsc") ? errorCode : "",
  //         bankDetailsIsVerified: false,
  //       }));
  //     });
  // }


  function checkBankDetails(accountNo, IFSC_Code, firmNameFromDialog = null) {
    setIsLoadingIfSC(true);
    setIsLoadingAccount(true);

    const postBody = {
      id_number: accountNo,
      ifsc: IFSC_Code,
    };

    getAccountDetails(postBody)
      .then((res) => {
        setIsLoadingIfSC(false);
        setIsLoadingAccount(false);

        if (res?.data?.data?.account_exists) {
          console.log("responce of bank details", res?.data?.data);

          const holderName = res.data.data.full_name;
          const holderNameNormalized = normalizeName(holderName);

          const gstBusinessName = normalizeName(cpDetails?.gstObject?.business_name);
          const reraAgentName = normalizeName(
            cpDetails?.reraExtracted?.agentName || cpDetails?.reraObject?.details?.[0]?.agent_name
          );
          const proprietorshipName = normalizeName(cpDetails?.proprietorshipName);
          const enteredFirmName = firmNameFromDialog ? normalizeName(firmNameFromDialog) : null;

          console.log("🔍 Normalized Holder Name:", holderNameNormalized);
          console.log("🔍 GST Business Name:", gstBusinessName);
          console.log("🔍 RERA Agent Name:", reraAgentName);
          console.log("🔍 Proprietorship Name:", proprietorshipName);
          console.log("🔍 Entered Firm Name:", enteredFirmName);

          let isValid = false;

          if (cpDetails?.gstApplicable === true) {
            // ✅ GST applicable — must match BOTH GST and RERA
            const matchesGST =
              !!gstBusinessName &&
              partialWordsMatch(holderNameNormalized, gstBusinessName);

            const matchesRERA =
              !!reraAgentName &&
              partialWordsMatch(holderNameNormalized, reraAgentName);

            // Require BOTH to be true
            isValid = matchesGST && matchesRERA;
          } else {
            // ✅ GST not applicable — match with RERA or Proprietorship (or entered firm name if asked)
            const matchesRera =
              !!reraAgentName &&
              partialWordsMatch(holderNameNormalized, reraAgentName);

            let matchesProp = false;
            let matchesEnteredFirm = false;

            if (!matchesRera) {
              if (proprietorshipName) {
                matchesProp = partialWordsMatch(holderNameNormalized, proprietorshipName);
              } else if (enteredFirmName) {
                matchesEnteredFirm = partialWordsMatch(holderNameNormalized, enteredFirmName);
              } else {
                // ⚠ No proprietorship name and no entered firm name — ask for it
                setIsLoadingIfSC(false);
                setIsLoadingAccount(false);
                setHelperText((pre) => ({
                  ...pre,
                  isHolderName: "",
                  isAccountNumber: "",
                  isIfscCode: "",
                  bankDetailsIsVerified: false,
                }));
                setAskFirmNameDialog(true);
                return;
              }
            }

            isValid = matchesRera || matchesProp || matchesEnteredFirm;
          }

          // Save bank holder name
          setBankDetails((pre) => ({
            ...pre,
            holderName: res.data.data.full_name,
          }));

          if (isValid) {
            console.log("✅ Bank holder name matched successfully");
            setHelperText((pre) => ({
              ...pre,
              isHolderName: "",
              isAccountNumber: "",
              isIfscCode: "",
              bankDetailsIsVerified: true,
            }));
          } else {
            console.log("❌ Bank holder name did not match");
            setHelperText((pre) => ({
              ...pre,
              isHolderName: cpDetails?.gstApplicable
                ? "Account holder name must partially match BOTH GST Business Name and RERA Name."
                : "Account holder name doesn't partially match RERA, Proprietorship Name, or Entered Firm Name.",
              isAccountNumber: "",
              isIfscCode: "",
              bankDetailsIsVerified: false,
            }));
          }
        } else {
          setHelperText((pre) => ({
            ...pre,
            isAccountNumber: "Something went wrong",
            isIfscCode: "Something went wrong",
            bankDetailsIsVerified: false,
          }));
        }
      })
      .catch((err) => {
        setIsLoadingIfSC(false);
        setIsLoadingAccount(false);
        console.error("Error:", err);

        const errorCode = err?.response?.data?.message_code || "Verification failed";

        setHelperText((pre) => ({
          ...pre,
          isAccountNumber: errorCode.includes("invalid_ifsc") ? "" : errorCode,
          isIfscCode: errorCode.includes("invalid_ifsc") ? errorCode : "",
          bankDetailsIsVerified: false,
        }));
      });
  }



  /**
   * Robust partial matching with debug logs:
   * - Case-insensitive
   * - Trims & collapses spaces
   * - Direct substring match first
   * - Then partial word match (≥4 letters) both ways
   * - Works even if spaces removed by normalization
   */
  function partialWordsMatch(nameA, nameB) {
    if (!nameA || !nameB) return false;

    const a = nameA.toLowerCase().trim().replace(/\s+/g, " ");
    const b = nameB.toLowerCase().trim().replace(/\s+/g, " ");

    console.log("🔍 Comparing:", a, "|", b);

    // 1️⃣ Direct substring match
    if (a.includes(b) || b.includes(a)) {
      console.log("✅ Direct substring match found");
      return true;
    }

    // 2️⃣ Word-based partial match
    const wordsA = a.split(" ").filter((w) => w.length > 3);
    const wordsB = b.split(" ").filter((w) => w.length > 3);

    console.log("WordsA:", wordsA, "WordsB:", wordsB);

    const matchFound = wordsA.some((word) =>
      wordsB.some((wb) => wb.includes(word) || word.includes(wb))
    );

    if (matchFound) {
      console.log("✅ Partial word match found");
    } else {
      console.log("❌ No match found");
    }

    return matchFound;
  }




  const inputfocus = (elmnt) => {
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      // const next = elmnt.target.tabIndex - 2;
      // if (next > -1) {
      //     // elmnt.target.form.elements[next].focus();
      //     if (elmnt.target.nextSibling)
      //         elmnt.target.nextSibling.focus();
      // }
    } else {
      console.log("next");
      // const next = elmnt.target.tabIndex + 1;
      const next = parseInt(elmnt.target.id.split("-")[1]) + 1;
      if (next < 5) {
        // elmnt.target.form.elements[next].focus();
        if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
      }
    }
  };
  function validatationCpDetails() {
    var form = true;

    console.log(cpDetails, "cpdetails======")
    if (cpDetails.panNumber === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isPanValid = "Please Enter Pan Number";
        return { ...preValue };
      });
    }
    if (cpDetails.gstApplicable === "true") {
      if (cpDetails.gstNumber === "") {
        form = false;
        setHelperText((preValue) => {
          preValue.isGstNumber = "Please Enter valid GST Number";
          return { ...preValue };
        });
      }
    } else {
      if (cpDetails.gstNumber === "") {
        setHelperText((preValue) => {
          preValue.isGstNumber = "";
          preValue.gstNumberVerified = false;
          return { ...preValue };
        });
      }
    }

    if (cpDetails.gstApplicable === "false") {
      setHelperText((preValue) => {
        preValue.isGstNumber = "";
        preValue.gstNumberVerified = false;
        return { ...preValue };
      });
    }

    // if (billingNameDisabled === false && cpDetails.billingName === "") {
    //   form = false;
    //   setHelperText((preValue) => {
    //     preValue.isBillingName = "Please Enter Billing Name";
    //     return { ...preValue };
    //   });
    // }
    // if (billingNameDisabled && cpDetails.billingName !== "") {
    //   setHelperText((preValue) => {
    //     preValue.isBillingName = "";
    //     return { ...preValue };
    //   });
    // }
    if (cpDetails.reraNumber === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.reraNumber = "Please Enter RERA Number";
        return { ...preValue };
      });
    } else if (helperText.reraVerified === false) {
      setHelperText((preValue) => {
        preValue.reraNumber = "Please Enter valid RERA Number";
        return { ...preValue };
      });
    } else {

      console.log("cptype============", cpType)
      if (cpDetails?.reraExtracted?.cpType === '' || cpDetails?.reraExtracted?.cpType === undefined || cpDetails?.reraExtracted?.cpType === null) {
        form = false;
        errorTost('Cannot able to find type of CP.Error while reading RERA Pdf');
      }
    }

    // if (cpDetails.reraDocument === "") {
    //   form = false;
    //   setHelperText((preValue) => {
    //     preValue.reraDocument = "Please Upload Rera Document";
    //     return { ...preValue };
    //   });
    // }
    if (cpDetails.recomendation === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.salesPersonName = "Please Enter Sales Person Name";
        return { ...preValue };
      });
    }
    if (cpDetails.msmeAvalaible === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isMemeNumber = "Please Select MSME Type";
        return { ...preValue };
      });
    }
    if (
      cpDetails.msmeAvalaible !== "Not Applicable" &&
      cpDetails.msmeNumber === ""
    ) {
      form = false;
      setHelperText((preValue) => {
        preValue.msmeNumber = "Please Enter MSME Number";
        return { ...preValue };
      });
    }
    if (cpDetails.msmeAvalaible === "No" && cpDetails.msmeNumber !== "") {
      setHelperText((preValue) => {
        preValue.msmeNumber = "";
        return { ...preValue };
      });
    }
    return {
      flag: form,
    };
  }
  function validateCpDetails() {
    console.log({ cpDetails });
    let flag = validatationCpDetails();
    if (
      flag.flag &&
      helperText.isPanValid === "" &&
      helperText.reraVerified === true &&
      helperText.isGstNumber === "" &&
      helperText.reraNumber === "" &&
      helperText.isBillingName === ""
    ) {
      // !!Save as Individual 
      if (reraPopUpYesSelected === true) {
        setCPType("Individual");
      }
      handleNext();
      // checkBillingNameExists(cpDetails.billingName)
      //   .then((resp) => {
      //     console.log(resp.length);
      //     if (resp.length > 0) {
      //       console.log("true");
      //       setHelperText((preValue) => {
      //         preValue.isBillingName = "Billing name already exist";
      //         return { ...preValue };
      //       });
      //     } else {
      //       // checkBillingNameExistsInFos(cpDetails.billingName)
      //       //   .then((fosResp) => {
      //       //     if (fosResp.length > 0) {
      //       //       console.log("true");
      //       //       setHelperText((preValue) => {
      //       //         preValue.isBillingName = "Billing name already exist";
      //       //         return { ...preValue };
      //       //       });
      //       //     } else {
      //       setHelperText((pre) => {
      //         pre.isBillingName = "";
      //         return { ...pre };
      //       });
      //       handleNext();
      //       //   }
      //       // })
      //       // .catch((err) => {
      //       //   handleErrors(err, "checkBillingNameExistsInFos");
      //       // });
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //     handleErrors(err, "checkBillingNameExists");
      //   });
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  function validateCpDetailsForButton() {
    var form = true;
    if (cpDetails.panNumber === "") {
      form = false;
    }
    if (helperText.isPanValid !== "") {
      form = false;
    }
    if (cpDetails.gstApplicable === "true") {
      if (cpDetails.gstNumber === "") {
        form = false;
      }
      if (helperText.isGstNumber !== "") {
        form = false;
      }
    }
    if (helperText.reraNumber !== "") {
      form = false;
    }

    if (cpDetails.billingName === "") {
      form = false;
    }
    if (helperText.isBillingName !== "") {
      form = false;
    }
    if (cpDetails.reraNumber === "") {
      form = false;
    }

    // if (cpDetails.reraDocument === "" || helperText.reraDocument !== "") {
    //   form = false;
    // }
    if (cpDetails.recomendation === "") {
      form = false;
    }
    if (cpDetails.msmeAvalaible === "") {
      form = false;
    }
    if (helperText.reraVerified === false) {
      form = false;
    }
    if (
      cpDetails.msmeAvalaible !== "Not Applicable" &&
      cpDetails.msmeNumber === ""
    ) {
      form = false;
    }
    if (cpType === '' || cpType === undefined || cpType === null) {
      form = false;
    }
    if (cpDetails.msmeAvalaible === "No" && cpDetails.msmeNumber !== "") {
      setHelperText((preValue) => {
        preValue.msmeNumber = "";
        return { ...preValue };
      });
    }
    return {
      flag: form,
    };
  }
  function validatePersonalDetailsForButton() {
    var form = true;
    if (helperText.isPersonName !== "" || personDetail.personaName === "") {
      form = false;
    }
    if (helperText.isEmail !== "" || personDetail.email === "") {
      form = false;
    }
    if (helperText.isPassword !== "" || personDetail.password === "") {
      form = false;
    }
    if (helperText.isPhoneNumber !== "" || personDetail.phoneNumber === "") {
      form = false;
    }
    if (verifiedPhoneNumber === false) {
      form = false;
    }
    if (verifiedEmail === false) {
      form = false;
    }
    return {
      flag: form,
    };
  }
  function validateBankDetailsForButton() {
    var form = true;
    // if (bankDetails.holderName === "" || helperText.isHolderName !== "") {
    //   form = false;
    // }
    if (bankDetails.accountNumber === "" || helperText.isAccountNumber !== "") {
      form = false;
    }
    if (bankDetails.ifscCode === "" || helperText.isIfscCode !== "") {
      form = false;
    }
    if (bankDetails.branchName === "") {
      form = false;
    }
    return {
      flag: form,
    };
  }
  const checkEmailExists = (email) => {
    checkCPExists(email)
      .then((resp) => {
        setIsLoadingEmail(false);
        if (resp.length === 0) {
          // If email does not exist, send OTP
          setHelperText((pre) => {
            pre.isEmail = "";
            return { ...pre };
          });
          setEmailLabelText('Send Otp'); // Show Send Otp button
        } else {
          // If email already exists, show error and don't show Send Otp button
          setHelperText((pre) => {
            pre.isEmail = "Email already exists";
            return { ...pre };
          });
          setEmailLabelText(''); // Hide Send Otp button
        }
      })
      .catch((err) => {
        setIsLoadingEmail(false);
        errorTost(err.message);
      });
  };
  const normalizePhone = (phone) => {
    if (!phone) return null;

    // remove +91 or any country code
    return Number(phone.replace(/\D/g, "").slice(-10));
  };

  const checkPhoneExists = (phone) => {
    const normalizedPhone = normalizePhone(phone);

    if (!normalizedPhone) return;

    setIsLoadingPhone(true);

    checkPhoneExistsApi(normalizedPhone)
      .then((resp) => {
        setIsLoadingPhone(false);

        if (resp.length === 0) {
          // ✅ NOT EXIST → proceed to blacklist check
          setHelperText((pre) => ({
            ...pre,
            isPhoneNumber: "",
          }));

          // 🔥 KEEP YOUR EXISTING FUNCTION HERE
          IsNumberBlackListed(phone);
        } else {
          // ❌ EXISTS → stop everything
          setHelperText((pre) => ({
            ...pre,
            isPhoneNumber: "Phone number already exists",
          }));

          setShowOtp(false);
          setVerifiedPhoneNumber(false);
        }
      })
      .catch((err) => {
        setIsLoadingPhone(false);
        errorTost(err.message);
      });
  };


  function smsTimeOutForEmailVerify() {
    if (verifiedEmail === false) {
      setHelperText((pre) => {
        pre.isEmail = "Otp has expired.Please resend otp";
        return { ...pre };
      });
      setOtpTimerEmail(false);
      setVerifiedEmail(false);
    }
    setShowEmailOtp(true);
    setOtpTimerEmail(true);
    setEmailState((pre) => {
      pre.otp1 = "";
      pre.otp2 = "";
      pre.otp3 = "";
      pre.otp4 = "";
      return { ...pre };
    });
    setRecievedEmailOtp(null);
  }
  function sendOtpToVerifyEmail() {
    setShowEmailOtp(true);
    setOtpTimerEmail(true);
    setEmailLabelText('');
    let body = {
      email: personDetail.email
    };
    sendOTPMessageMail(body).then((resp) => {
      if (resp.data.success) {
        var bytes = CryptoJS.AES.decrypt(resp.data.otp, 'hts secret key');
        var originalText = bytes.toString(CryptoJS.enc.Utf8);
        console.log("FOS Email Registration OTP", parseInt(originalText));
        setRecievedEmailOtp(parseInt(originalText));
        // 900000 ;15 min
        const myTimeout = setTimeout(smsTimeOutForEmailVerify, 900000);
      } else {
        if (resp?.data?.error?.ErrorMessage) {
          errorTost(resp?.data?.error?.ErrorMessage);
        } else {
          errorTost("Something went wrong");
        }
      }
    });
  }
  // !!For Email
  function submitEmailOtp() {
    let finalValue = emailState.otp1 + emailState.otp2 + emailState.otp3 + emailState.otp4;
    console.log(finalValue, "recievedEmailOtp", recievedEmailOtp);
    if (finalValue == recievedEmailOtp) {
      setVerifiedEmail(true);
      setShowEmailOtp(false);
      setOtpTimerEmail(false);
      setEmailLabelText('');
    } else {
      setEmailState((pre) => {
        pre.otp1 = "";
        pre.otp2 = "";
        pre.otp3 = "";
        pre.otp4 = "";
        return { ...pre };
      });
      errorTost("OTP doesnt match.Please enter valid otp");
    }
  }
  // !!Email otp
  function optEmailChange(value1, event) {
    event.preventDefault();
    setEmailState((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }
  const IsNumberBlackListed = debounce((e) => {
    console.log(e);
    checkPhoneNumberIsBlackListed(e)
      .then((resp) => {
        console.log(resp);
        if (resp.length > 0) {
          setVerifiedPhoneNumber(false);
          setHelperText((pre) => {
            pre.isPhoneNumber = "";
            return { ...pre };
          });
          // setHelperText((pre) => {
          //   pre.isPhoneNumber = "This number is already in use!";
          //   return { ...pre };
          // });
        } else {
          // setVerifiedPhoneNumber(true);
          setHelperText((pre) => {
            pre.isPhoneNumber = "";
            return { ...pre };
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, 800);
  function validationPersonDetails() {
    var form = true;
    if (personDetail.personaName === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isPersonName = "Please Enter Person Name";
        return { ...preValue };
      });
    }
    if (personDetail.phoneNumber === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isPhoneNumber = "Please Enter Phone Number";
        return { ...preValue };
      });
    } else {
      if (verifiedPhoneNumber === false) {
        errorTost("Please verify phone number");
      }
    }

    if (personDetail.email === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isEmail = "Please Enter Email Id";
        return { ...preValue };
      });
    } else {
      if (verifiedEmail === false) {
        errorTost("Please verify email");

      }
    }
    if (personDetail.password === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isPassword = "Please Enter Password";
        return { ...preValue };
      });
    }
    return {
      flag: form,
    };
  }
  function validatePersonaDetails() {
    let flag = validationPersonDetails();
    if (
      flag.flag &&
      helperText.isPersonName === "" &&
      helperText.isPhoneNumber === "" &&
      helperText.isEmail === "" &&
      helperText.isPassword === "" &&
      verifiedPhoneNumber && verifiedEmail
    ) {
      handleNext();
    }
  }
  function validatationBankDetails() {
    var form = true;
    // if (bankDetails.holderName === "") {
    //   form = false;
    //   setHelperText((preValue) => {
    //     preValue.isHolderName = "Please Enter Holder Name";
    //     return { ...preValue };
    //   });
    // }
    if (bankDetails.accountNumber === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isAccountNumber = "Please Enter Account Number";
        return { ...preValue };
      });
    }
    if (bankDetails.ifscCode === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isIfscCode = "Please Enter IFSC code";
        return { ...preValue };
      });
    }
    if (bankDetails.branchName === "") {
      form = false;
      setHelperText((preValue) => {
        preValue.isBranchName = "Please Enter Branch Name";
        return { ...preValue };
      });
    }

    if (helperText.isIfscCode !== "") {
      form = false;
    }
    return {
      flag: form,
    };
  }
  // function validateBankDetails() {
  //   let flag = validatationBankDetails();
  //   console.log({ helperText }, { bankDetails });
  //   if (
  //     flag.flag &&
  //     helperText.isIfscCode === "" &&
  //     helperText.isAccountNumber === "" &&
  //     helperText.isHolderName === ""
  //   ) {
  //     Network.getStatus().then((status) => {
  //       if (status.connected) {
  //         presentLoader();
  //         signUpCP(cpDetails, personDetail, bankDetails, cpType, reraEndDate, reraStartDate, agentType)
  //           .then((user) => {
  //             getCpId(user.id)
  //               .then((res) => {
  //                 console.log(res);
  //                 let reraDocumentName = res[0].cpId + "_rera.pdf";
  //                 cpDetails.docUrl = "kycdocuments/CpDocuments/" + res[0].cpId + "_rera.pdf";
  //                 addKYCDoc(res[0].cpId, cpDetails, cpDetails.gstApplicable)
  //                   .then((res) => {
  //                     console.log(res);
  //                     getCPUId(cpDetails.billingName)
  //                       .then((resp) => {
  //                         console.log('To Show, CPID', resp[0].cpDisplayId);
  //                         setCpDisplayId("CPID" + resp[0].cpDisplayId);
  //                         let message = `<h4>Hello ${cpDetails.billingName}</h4></br>
  //                       <p>You have successfully registered with us and here are your login credentials.</p>
  //                       <p>User ID: <b>${"CPID" + resp[0].cpDisplayId}</b></p></br>
  //                       <p>Password: <b>${personDetail.password}</b></p>
  //                     <p>Regards,</p>
  //                     <p>Vilas Javdekar Developers</p>`;
  //                         //     let message = `<h4>Hello ${cpDetails.billingName}</h4></br>
  //                         //   <p>You have successfully registered with us and here are your login credentials.</p>
  //                         // <p>User ID: <b>${"CPID" + resp[0].cpDisplayId}</b></p></br>
  //                         // <p>Password: <b>${personDetail.password}</b></p>
  //                         // <p>Regards,</p>
  //                         // <p>Vilas Javdekar Developers</p>`;
  //                         sendMail(personDetail.email, "Registered Successfully", message);

  //                         // **message
  //                         let messageBody = {
  //                           number: personDetail?.phoneNumber,      // ! extra + here
  //                           "message": `Hello ${cpDetails.billingName}\nYou have successfully registered with us and here are your login credentials.\nUser ID : CPID${resp[0].cpDisplayId}\nPassword : ${personDetail.password}\npartners.vjerp.com\nRegards,\nVilas Javdekar Developers`,
  //                           // number: "+" + personDetail?.phoneNumber,
  //                           //  ! below format gives template error
  //                           //                             message: `Hello ${cpDetails.billingName}

  //                           // You have successfully registered with us and here are your login credentials.

  //                           // User ID : CPID${resp[0].cpDisplayId}
  //                           // Password : ${personDetail.password}

  //                           // partners.vjerp.com

  //                           // Regards,
  //                           // Vilas Javdekar Developers`,
  //                           // message: `Hello ${cpDetails.billingName},You have successfully registered with us and here are your login credentials.Your User ID:${"CPID" +
  //                           //   resp[0].cpDisplayId.replace(
  //                           //     resp[0].cpDisplayId.substring(8, 12),
  //                           //     "-" + resp[0].cpDisplayId.substring(8, 12)
  //                           //   )
  //                           //   }.Password:${personDetail.password}.Regards, Vilas Javdekar Developers`,
  //                           is_international_number: personDetail?.phoneNumber.toString().substring(1, 3) !== "91" ? true : false,
  //                         };
  //                         console.log('personDetail?.phoneNumber: ', personDetail?.phoneNumber);
  //                         console.log('messageBody: ', messageBody);
  //                         sendMessage(messageBody)
  //                           .then((resp) => {
  //                             if (resp.data.success) {
  //                               return true;
  //                             } else {
  //                               if (resp?.data?.error) {
  //                                 return false;
  //                               }
  //                             }
  //                           })
  //                           .catch((err) => {
  //                             console.log(err.message);
  //                             return false;
  //                           });
  //                       })
  //                       .catch((err) => {
  //                         console.log(err);
  //                       });

  //                     dismissLoader();
  //                     handleNext();
  //                     setHideBackButton(true);
  //                     successTost("User Added Successfully");
  //                   })
  //                   .catch((err) => {
  //                     dismissLoader();
  //                     handleErrors(err, "signUpCP->addKyc");
  //                   });
  //                 uploadFileToDb(reraDocumentName, cpDetails.reraDocument)
  //                   .then((response) => {
  //                     // **While changing sequence of upload fileto db  
  //                     // cpDetails.docUrl = response.Key;
  //                   })
  //                   .catch((err) => {
  //                     dismissLoader();
  //                     handleErrors(err, "signUpCP->uploadReraDoc");
  //                   });
  //               })
  //               .catch((err) => {
  //                 dismissLoader();
  //                 handleErrors(err, "signUpCP->getCp");
  //               });
  //           })
  //           .catch((err) => {
  //             dismissLoader();
  //             console.log(err);
  //             handleErrors(err, "signUpCP", cpDetails.billingName);
  //           });
  //       } else {
  //         offlineToast();
  //       }
  //     });
  //   }
  // }


  async function validateBankDetails() {
    let flag = validatationBankDetails();
    console.log({ helperText }, { bankDetails });

    if (
      flag.flag &&
      helperText.isIfscCode === "" &&
      helperText.isAccountNumber === "" &&
      helperText.isHolderName === ""
    ) {
      Network.getStatus().then((status) => {
        if (status.connected) {
          presentLoader();
          signUpCP(
            cpDetails,
            personDetail,
            bankDetails,
            cpType,
            reraEndDate,
            reraStartDate,
            agentType
          )
            .then((user) => {
              getCpId(user.id)
                .then(async (res) => {
                  console.log(res);
                  const cpId = res[0].cpId;
                  console.log("✅ Got cpId:", cpId);

                  // ---- upload Shop Act here ----
                  if (shopActFile) {
                    try {
                      const ext = shopActFile.name.split(".").pop();
                      const fileName = `${cpId}_shopact.${ext}`;
                      const filePath = `cpshopact/${fileName}`;

                      const { error: uploadError } = await supabase.storage
                        .from("kycdocuments")
                        .upload(filePath, shopActFile, {
                          cacheControl: "3600",
                          upsert: true,
                        });

                      if (uploadError) {
                        console.error("❌ Shop Act upload failed:", uploadError);
                        errorTost("Failed to upload Shop Act document.");
                      } else {
                        console.log("✅ Shop Act uploaded:", filePath);
                        cpDetails.shopActUrl = `kycdocuments/${filePath}`; // now we save URL
                      }
                    } catch (err) {
                      console.error("❌ Exception while uploading Shop Act:", err);
                      errorTost("Failed to upload Shop Act document.");
                    }
                  }


                  let reraDocumentName = res[0].cpId + "_rera.pdf";
                  cpDetails.docUrl =
                    "kycdocuments/CpDocuments/" + res[0].cpId + "_rera.pdf";
                  addKYCDoc(cpId, cpDetails, cpDetails.gstApplicable)
                    .then((res) => {
                      console.log(res);
                      getCPUId(cpDetails.billingName)
                        .then((resp) => {
                          console.log("To Show, CPID", resp[0].cpDisplayId);
                          setCpDisplayId("CPID" + resp[0].cpDisplayId);
                          let message = `<h4>Hello ${cpDetails.billingName}</h4></br>
                        <p>You have successfully registered with us and here are your login credentials.</p>
                        <p>User ID: <b>${"CPID" + resp[0].cpDisplayId}</b></p></br>
                        <p>Password: <b>${personDetail.password}</b></p>
                      <p>Regards,</p>
                      <p>Vilas Javdekar Developers</p>`;
                          sendMail(
                            personDetail.email,
                            "Registered Successfully",
                            message
                          );

                          // **message
                          let messageBody = {
                            number: personDetail?.phoneNumber,
                            message: `Hello ${cpDetails.billingName}\nYou have successfully registered with us and here are your login credentials.\nUser ID : CPID${resp[0].cpDisplayId}\nPassword : ${personDetail.password}\npartners.vjerp.com\nRegards,\nVilas Javdekar Developers`,
                            is_international_number:
                              personDetail?.phoneNumber
                                .toString()
                                .substring(1, 3) !== "91"
                                ? true
                                : false,
                          };
                          console.log(
                            "personDetail?.phoneNumber: ",
                            personDetail?.phoneNumber
                          );
                          console.log("messageBody: ", messageBody);
                          sendMessage(messageBody)
                            .then((resp) => {
                              if (resp.data.success) {
                                return true;
                              } else {
                                if (resp?.data?.error) {
                                  return false;
                                }
                              }
                            })
                            .catch((err) => {
                              console.log(err.message);
                              return false;
                            });
                        })
                        .catch((err) => {
                          console.log(err);
                        });

                      dismissLoader();
                      handleNext();
                      setHideBackButton(true);
                      successTost("User Added Successfully");
                    })
                    .catch((err) => {
                      dismissLoader();
                      handleErrors(err, "signUpCP->addKyc");
                    });
                  uploadFileToDb(reraDocumentName, cpDetails.reraDocument)
                    .then((response) => {
                      // **While changing sequence of upload fileto db  
                      // cpDetails.docUrl = response.Key;
                    })
                    .catch((err) => {
                      dismissLoader();
                      handleErrors(err, "signUpCP->uploadReraDoc");
                    });
                })
                .catch((err) => {
                  dismissLoader();
                  handleErrors(err, "signUpCP->getCp");
                });
            })
            .catch((err) => {
              dismissLoader();
              console.log(err);
              handleErrors(err, "signUpCP", cpDetails.billingName);
            });
        } else {
          offlineToast();
        }
      });
    }
  }

  function sendMail(email, subject, message) {
    let body = {
      to: [email],
      subject: subject,
      message: message,
    };
    console.log('body: ', body);
    sendMailTo(body).then((resp) => {
      console.log(resp);
    })
      .catch((err) => {
        console.log(err);
      });
  }


  // ✅ Add this helper anywhere above your component return (e.g., near other helpers)
  const validateCertificateFormat = (text) => {
    if (!text) return false;

    /**
     * COMMON mandatory identifiers (must exist in ALL formats)
     */
    const commonPatterns = [
      /REGISTRATION\s+CERTIFICATE\s+OF\s+REAL\s+ESTATE\s+AGENT/i,
      /FORM\s*'?H'?/i,
      /Maharashtra\s+Real\s+Estate\s+Regulatory\s+Authority/i,
      /This\s+registration\s+is\s+granted/i
    ];

    /**
     * Signature line variants
     */
    const signaturePatterns = [
      /Signature\s+and\s+seal\s+of\s+the\s+Authorized\s+Officer/i,
      /Signature\s+and\s+seal\s+of\s+Secretary,\s*MahaRERA/i
    ];

    /**
     * Certificate number variants
     * A + 11 or 12 digits (both seen in real certificates)
     */
    const certNoOk = /A\d{11,12}/i.test(text);

    /**
     * Validity line variants
     */
    const validityPatterns = [
      /commencing\s+from\s+\d{2}\/\d{2}\/\d{4}\s+and\s+ending\s+with\s+\d{2}\/\d{2}\/\d{4}/i,
      /valid\s+for\s+a\s+period\s+of\s+.*commencing\s+from\s+\d{2}\/\d{2}\/\d{4}\s+and\s+ending\s+with\s+\d{2}\/\d{2}\/\d{4}/i
    ];

    const hasCommon = commonPatterns.every(rx => rx.test(text));
    const hasSignature = signaturePatterns.some(rx => rx.test(text));
    const hasValidity = validityPatterns.some(rx => rx.test(text));

    return hasCommon && hasSignature && certNoOk && hasValidity;
  };





  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.wrapperContent}>







        <ReraUploadModal
          open={showUpload}
          onClose={() => setShowUpload(false)}
          onExtractData={(text) => {


            // 🔒 Strict format validation for MahaRERA Agent Certificate (Form 'H')
            if (!validateCertificateFormat(text)) {
              setHelperText((pre) => ({
                ...pre,
                reraVerified: false,
                reraNumber:
                  "Invalid RERA certificate format. Please upload the official MahaRERA Agent Registration Certificate.",
              }));
              errorTost("Uploaded PDF doesn't match the expected RERA certificate format.");
              setIsReraLoading(false);
              return;
            }



            const parsed = parseCertificateText(text);

            if (!parsed.startDate || !parsed.endDate) {
              setHelperText((pre) => ({
                ...pre,
                reraVerified: false,
                reraNumber: "Start/End date missing in certificate.",
              }));
              setShowReraUploadDialog(true);
              return;
            }

            // ✅ Extract certificate number from PDF
            // ✅ Extract certificate number from PDF (supports old + new)
            const certificateRegex = /A\d{11,12}/i;
            const match = text.match(certificateRegex);
            const extractedCertNumber = match ? match[0].trim().toUpperCase() : "";


            // 🛠️ FIXED: Replaced generalDetail with cpDetails (or your actual state)
            const inputCertNumber = cpDetails?.reraNumber?.trim().toUpperCase() || "";

            console.log("📜 Extracted Certificate No:", extractedCertNumber);
            console.log("🖊️ Input Certificate No:", inputCertNumber);

            // ❌ Validate extracted certificate number
            if (!extractedCertNumber || inputCertNumber !== extractedCertNumber) {
              setHelperText((pre) => ({
                ...pre,
                reraVerified: false,
                reraNumber: "Certificate number mismatch! Please check input or uploaded PDF.",
              }));
              errorTost("RERA Certificate number does not match the entered number.");
              return;
            }

            // ✅ Get agentName from RERA API response
            const agentName = cpDetails?.reraObject?.details?.[0]?.agent_name || "";

            console.log("📅 Start Date:", new Date(parsed.startDate).toLocaleDateString());
            console.log("📅 End Date:", new Date(parsed.endDate).toLocaleDateString());
            console.log("👤 CP Type:", parsed.cpType || "Individual");
            console.log("🏷️ Agent Name from API:", agentName);

            const cpType = parsed.cpType || "Individual";

            // 🟢 Set extracted values
            setReraStartDate(parsed.startDate);
            setReraEndDate(parsed.endDate);

            setCpDetails((prev) => ({
              ...prev,
              reraExtracted: {
                agentName,
                typeOfAgent: parsed.typeOfAgent,
                startDate: parsed.startDate,
                endDate: parsed.endDate,
                cpType,
              },
              cpType,
            }));

            setHelperText((pre) => ({
              ...pre,
              reraVerified: true,
              reraNumber: "",
            }));

            setIsReraLoading(false);

            // ✅ Normalize Names
            const normalizeName = (name) =>
              name
                ?.replace(/PVT\.?\s*LTD\.?/gi, "PRIVATE LIMITED")
                ?.replace(/[.,]/g, "")
                ?.replace(/\s+/g, " ")
                ?.trim()
                ?.toUpperCase();

            const gstin = cpDetails?.gstNumber?.trim();
            const isMaharashtraGST = gstin?.startsWith("27") && cpDetails?.gstApplicable;

            const agentNameRERA = normalizeName(agentName);
            const gstBusinessName = normalizeName(cpDetails?.gstObject?.business_name);
            const gstLegalName = normalizeName(cpDetails?.gstObject?.legal_name);
            const panName = normalizeName(cpDetails?.panObject?.full_name);

            console.log("📤 Normalized Names:");
            console.log("🔹 RERA Agent Name:", agentNameRERA);
            console.log("🔹 GST Business Name:", gstBusinessName);
            console.log("🔹 GST Legal Name:", gstLegalName);
            console.log("🔹 PAN Name:", panName);

            // ✅ Matching Logic
            if (isMaharashtraGST) {
              if (
                agentNameRERA &&
                (wordsMatch(agentNameRERA, gstBusinessName) ||
                  wordsMatch(agentNameRERA, gstLegalName))
              ) {
                setCpDetails((prev) => ({
                  ...prev,
                  billingName: agentNameRERA,
                }));
                setHelperText((pre) => ({
                  ...pre,
                  isBillingName: "",
                }));
              } else {
                console.warn("⚠️ GST Name mismatch — showing RERA popup.");
                setReraPopUp(true);
                setLedgerName(agentNameRERA);
                setMessage("RERA Name does not match GST Business/Legal Name! Please verify or create as CP Individual.");
                setHelperText((pre) => ({
                  ...pre,
                  isBillingName: "Mismatch: RERA Name ≠ GST Business/Legal Name",
                }));
              }
            } else {
              if (
                panName &&
                agentNameRERA &&
                (panName === agentNameRERA ||
                  agentNameRERA.includes(panName) ||
                  panName.includes(agentNameRERA))
              ) {
                setCpDetails((prev) => ({
                  ...prev,
                  billingName: agentNameRERA,
                }));
                setHelperText((pre) => ({
                  ...pre,
                  isBillingName: "",
                }));
              } else {
                console.warn("⚠️ PAN Name mismatch — checking proprietorship option.");

                if (!cpDetails?.gstApplicable) {
                  setLedgerName(agentNameRERA);
                  setMessage("RERA Name does not fully match PAN Name. Is this a Proprietorship?");
                  setShowProprietorshipDialog(true);
                  return;
                }

                setCpDetails((prev) => ({
                  ...prev,
                  billingName: agentNameRERA,
                }));
                setLedgerName(agentNameRERA);
                setMessage("PAN Name does not match RERA Name! Please enter your Proprietorship/Firm Name.");
                setHelperText((pre) => ({
                  ...pre,
                  isBillingName: "",
                }));
                setAskFirmNameDialog(true);
              }
            }

            // ✅ Close modal after successful processing
            setShowUpload(false);
          }}
        />




        <Dialog
          open={showProprietorshipDialog}
          disableEscapeKeyDown
          onClose={(event, reason) => {
            // Prevent closing on backdrop click
            if (reason === "backdropClick") return;
            setShowProprietorshipDialog(false);
          }}
        >
          <DialogTitle>Proprietorship Confirmation</DialogTitle>
          <DialogContent>
            <DialogContentText>
              RERA Name Does Not Match With PAN Name. Is this a Proprietorship?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <MUIButton
              variant="contained"
              onClick={() => {
                setShowProprietorshipDialog(false);
                setAskFirmNameDialog(true);
              }}
            >
              Yes
            </MUIButton>
            <MUIButton
              variant="contained"
              // color="error"
              onClick={() => {
                setShowProprietorshipDialog(false);
                setHelperText((pre) => ({
                  ...pre,
                  isBillingName: "RERA Name does not match PAN Name",
                }));
              }}
            >
              No
            </MUIButton>
          </DialogActions>
        </Dialog>



        <AskFirmNameDialog
          open={askFirmNameDialog}
          onClose={handleFirmDialogClose}
          onConfirm={handleFirmDialogConfirm}
        // onConfirm={handleFirmConfirm} 
        />
        <FullScreenLoader open={isReraLoading} message="RERA verifying..." />


        <img className={cssClasses.block} src={logo} alt={""}></img>
        {hideBackButton === false && (
          <img
            className={cssClasses.backArrow}
            src={backArrow}
            onClick={handleBack}
            alt={"backArrow"}
            tabIndex="0"
          ></img>
        )}

        <div className={cssClasses.wrapperStepper}>
          <MobileStepper
            variant="progress"
            className={classes.stepper}
            steps={totalSteps}
            position="static"
            activeStep={activeStep}
            sx={{
              maxWidth: "100%",
              // maxWidth:600,
              flexGrow: 1,
              margin: "0 auto",
              background: "#F5F5F5 !important",
            }}
          />
        </div>
        {totalSteps - activeStep - 1 !== 0 ? (
          <div className={cssClasses.label}>
            {totalSteps - activeStep - 1} Steps to your account creation
          </div>
        ) : (
          <div className={cssClasses.label}>Account Created</div>
        )}
        {activeStep === 1 && (
          <div className={cssClasses.wrapperDetailsSubmitted}>
            <div className={cssClasses.detailText}>CP Type</div>
            <div style={{ textAlign: "center" }}>
              <FormControl>
                {/* <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel> */}
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={type}
                  sx={{
                    "& .MuiSvgIcon-root": {
                      color: "#155EEF !important",
                      fontSize: "2rem !important",
                    },
                  }}
                  onChange={(e) => {
                    setType(e.target.value);
                    if (e.target.value === "FoS") {
                      navigate("/FosRegisteration");
                    }
                  }}
                >
                  <FormControlLabel
                    className={classes.radioLabel}
                    value={"CP"}
                    control={<Radio />}
                    label={<div className={classes.radioLabel}>CP</div>}
                  />
                  {/* <FormControlLabel
                    className={classes.radioLabel}
                    value={"Individual"}
                    control={<Radio />}
                    label={<div className={classes.radioLabel}>Individual</div>}
                  /> */}
                  <FormControlLabel
                    className={classes.radioLabel}
                    value={"FoS"}
                    control={<Radio />}
                    label={<div className={classes.radioLabel}>FoS</div>}
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <Button
              style={{
                color: "#ffffff",
                backgroundColor: "#155EEF",
                border: "1px solid #155EEF",
              }}
              btnName={"Proceed"}
              clicked={handleNext}
              btnIcon={<RightArrow />}
              iconPosition={"right"}
            />
          </div>
        )}
        {activeStep === 2 && (
          <div className={cssClasses.wrapperContactDeatils}>
            <div className={cssClasses.detailText}>Terms and Conditions</div>
            <div className={cssClasses.wrapperInnerContent}>
              <div>
                <div className={cssClasses.welcomeMessage}>
                  {TermsAndConditionJson.welcomeMessage}
                </div>
                {TermsAndConditionJson.agreementArray.map((each, index) => {
                  return (
                    <div className={cssClasses.wrapperTermsAndConditionsIndex}>
                      <div className={cssClasses.termsAndConditionsIndex}>
                        {index + 1}. {each.title}
                      </div>
                      <div className={cssClasses.welcomeMessage}>
                        {each.message}
                      </div>
                      <div className={cssClasses.welcomeMessage}>
                        {each.note}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }} />
                  }
                  checked={acceptTermsAndConditions}
                  label={
                    <div className={classes.radioLabel}>
                      I agree with the Terms and Conditions
                    </div>
                  }
                  onChange={(e) => {
                    console.log(e.target.checked);
                    setAcceptTermsAndConditions(e.target.checked);
                  }}
                />
              </FormGroup>
            </div>
            <div>
              {acceptTermsAndConditions ? (
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                    border: "1px solid #155EEF",
                  }}
                  btnName={"Accept"}
                  clicked={() => {
                    handleNext();
                  }}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              ) : (
                <Button
                  style={{
                    color: "#155EEF",
                    backgroundColor: "#ffffff",
                    border: "1px solid #155EEF",
                  }}
                  btnName={"Accept"}
                  clicked={() => { }}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              )}
            </div>
          </div>
        )}
        {activeStep === 3 && (
          <div className={cssClasses.wrapperContactDeatils}>
            <div className={cssClasses.detailText}>CP Details</div>
            <div className={cssClasses.wrapperInnerContent}>
              <div style={{ textTransform: "uppercase" }}>
                <CustomInput
                  value={cpDetails.panNumber}
                  label={"PAN Number"}
                  disabled={helperText.panVerified}
                  mandatory={true}
                  handleChange={(newValue) => {
                    console.log(newValue.length);
                    newValue = newValue.trim();
                    var regex = /([A-Z*\sa-z]){5}([0-9]){4}([A-Z*\sa-z]){1}$/;
                    if (newValue.length <= 10) {
                      if (!regex.test(newValue)) {
                        helperText.panVerified = false;
                        helperText.isPanValid =
                          "Please enter Valid PAN number.";
                        setCpDetails((pre) => {
                          pre.billingName = "";
                          return Object.assign({}, pre);
                        });
                        setBillingNameDisabled(false);
                      } else {
                        helperText.isPanValid = "verifying...";
                        if (newValue.length === 10) {
                          // if(_isValid.flag) {
                          setIsLoadingPan(true);
                          PAN_CardCheck(newValue.toUpperCase());
                        }
                      }
                      setCpDetails((pre) => {
                        pre["panNumber"] = newValue;
                        return Object.assign({}, pre);
                      });
                    }
                  }}
                  placeholder="Enter PAN Number"
                  inputType="label"
                  helperText={helperText.isPanValid}
                  isLoading={isLoadingPan}
                  greenTick={helperText.panVerified}
                />
              </div>
              <div>
                <div className={cssClasses.blockLabel}>
                  GST Applicable <span style={{ color: "red" }}> *</span>
                </div>
                <FormControl>
                  {/* <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel> */}
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    sx={{
                      "& .MuiSvgIcon-root": {
                        color: "#155EEF !important",
                        fontSize: "2rem !important",
                      },
                    }}
                    value={cpDetails.gstApplicable}
                    onChange={(e) => {
                      cpDetails.gstNumber = "";
                      helperText.gstNumberVerified = false;
                      console.log(typeof e.target.value);
                      setCpDetails((pre) => {
                        pre.gstApplicable = e.target.value;
                        return Object.assign({}, pre);
                      });
                    }}
                  >
                    <FormControlLabel
                      className={classes.radioLabel}
                      value={true}
                      control={<Radio />}
                      label={<div className={classes.radioLabel}>Yes</div>}
                    />
                    <FormControlLabel
                      className={classes.radioLabel}
                      value={false}
                      control={<Radio />}
                      label={<div className={classes.radioLabel}>No</div>}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              {/* {cpDetails.gstApplicable === "true" && (
                <div style={{ textTransform: "uppercase" }}>
                 



<CustomInput
  value={cpDetails.gstNumber}
  label={"GST Number"}
  mandatory={true}
  inputType="label"
  position="end" // Button on the right side inside input
  labelText={!helperText.gstNumberVerified
      ? "Verify"
      : ""} // Button text inside input
  disabled={helperText.gstNumberVerified} // disable if already verified
  greenTick={helperText.gstNumberVerified}
  isLoading={isGSTLoading}
  placeholder="Enter GST Number"
  helperText={helperText.isGstNumber}
  handleChange={(newValue) => {
    const validInput = /^[0-9A-Z]*$/;
    newValue = newValue.toUpperCase().trim();

    if (!validInput.test(newValue)) return;

    setCpDetails((pre) => ({
      ...pre,
      gstNumber: newValue,
    }));

    setHelperText((pre) => ({
      ...pre,
      gstNumberVerified: false,
      isGstNumber: newValue === "" ? "Please Enter GST Number" : "",
    }));
  }}
  clicked={() => {
    if (!cpDetails.billingName) {
      errorTost("Please Enter PAN Number First");
      return;
    }
    if (!cpDetails.gstNumber) {
      errorTost("Please Enter GST Number");
      return;
    }

    setHelperText((pre) => ({
      ...pre,
      isGstNumber: "verifying...",
    }));
    setIsGSTLoading(true);
    gstInfoApiCall(cpDetails.gstNumber); // ✅ Your API call
  }}
/>


                </div>
              )} */}

              {cpDetails.gstApplicable === "true" && (
                <div style={{ textTransform: "uppercase" }}>
                  <div className={cssClasses.blockLabel}>
                    GST Number <span style={{ color: "red" }}> *</span>
                  </div>

                  {/* Multiple GST numbers case */}
                  {activeGSTOptions?.length > 1 ? (
                    <Dropdown
                      list={activeGSTOptions.map((gst) => ({
                        label: gst,
                        value: gst,
                      }))} // ✅ Send all GST numbers
                      placeHolder={"Select GST Number"}
                      selectedValue={cpDetails.gstNumber}
                      style={{ background: "#F2F4F7", color: "rgb(102, 112, 133)" }}
                      greenTick={helperText.gstNumberVerified}
                      onChangeSelect={(selectedGST) => {
                        // 1️⃣ Set GST number
                        setCpDetails((pre) => ({
                          ...pre,
                          gstNumber: selectedGST,
                        }));

                        // 2️⃣ Reset verification
                        setHelperText((pre) => ({
                          ...pre,
                          gstNumberVerified: false,
                          isGstNumber: "verifying...",
                        }));

                        // 3️⃣ PAN required first
                        if (!cpDetails.billingName) {
                          errorTost("Please Enter PAN Number First");
                          return;
                        }

                        // 4️⃣ Call GST API
                        setIsGSTLoading(true);
                        getGSTInfo(selectedGST)
                          .then((res) => {
                            setIsGSTLoading(false);

                            const gstData = res.data.data;
                            const extractedPANFromGST = selectedGST.substring(2, 12);
                            const panFromCp = cpDetails?.panObject?.pan_number;

                            if (extractedPANFromGST !== panFromCp) {
                              setHelperText((pre) => ({
                                ...pre,
                                isGstNumber: "PAN and GST Number do not match.",
                                gstNumberVerified: false,
                              }));
                              errorTost("PAN in GST doesn't match the provided PAN.");
                              return;
                            }

                            // ✅ Success
                            setHelperText((pre) => ({
                              ...pre,
                              gstNumberVerified: true,
                              isGstNumber: "",
                            }));

                            setCpDetails((pre) => ({
                              ...pre,
                              gstObject: gstData,
                            }));
                          })
                          .catch((err) => {
                            setIsGSTLoading(false);
                            setHelperText((pre) => ({
                              ...pre,
                              gstNumberVerified: false,
                              isGstNumber: err.message || "GST verification failed",
                            }));
                            errorTost(err.message);
                          });
                      }}
                      helperText={helperText.isGstNumber}
                    />
                  ) : (
                    // Single GST case
                    <CustomInput
                      value={cpDetails.gstNumber}
                      inputType="label"
                      position="end"
                      labelText={!helperText.gstNumberVerified ? "Verify" : ""}
                      disabled={helperText.gstNumberVerified}
                      greenTick={helperText.gstNumberVerified}
                      isLoading={isGSTLoading}
                      placeholder="Enter GST Number"
                      helperText={helperText.isGstNumber}
                      handleChange={(newValue) => {
                        const validInput = /^[0-9A-Z]*$/;
                        newValue = newValue.toUpperCase().trim();
                        if (!validInput.test(newValue)) return;

                        setCpDetails((pre) => ({
                          ...pre,
                          gstNumber: newValue,
                        }));

                        setHelperText((pre) => ({
                          ...pre,
                          gstNumberVerified: false,
                          isGstNumber: newValue === "" ? "Please Enter GST Number" : "",
                        }));
                      }}
                      clicked={() => {
                        if (!cpDetails.billingName) {
                          errorTost("Please Enter PAN Number First");
                          return;
                        }
                        if (!cpDetails.gstNumber) {
                          errorTost("Please Enter GST Number");
                          return;
                        }
                        setHelperText((pre) => ({
                          ...pre,
                          isGstNumber: "verifying...",
                        }));
                        setIsGSTLoading(true);
                        gstInfoApiCall(cpDetails.gstNumber);
                      }}
                    />
                  )}
                </div>
              )}








              <div style={{ textTransform: "uppercase" }}>
                {/* <CustomInput
                  value={cpDetails.reraNumber}
                  label={"RERA Number"}
                  mandatory={true}
                  handleChange={(newValue) => {
                    newValue = newValue.trim();
                    var numbers = /^[a-zA-Z0-9]*$/;
                    // console.log(numbers.test(newValue));
                    if (
                        cpDetails.billingName.trim() !== "" &&
                        newValue.length <= 13 &&
                        numbers.test(newValue)
                      ) {
                      if ((newValue.length === 12 || newValue.length === 13) && newValue.length !== 0) {
                        setHelperText((pre) => {
                          pre.reraNumber = "verifying";
                          return { ...pre };
                        });
                        setIsReraLoading(true);
                        reraApiCall(newValue.toUpperCase());
                      }
                      setHelperText((pre) => {
                        pre.reraVerified = false;
                        return { ...pre };
                      });
                      setCpDetails((pre) => {
                        pre.reraNumber = newValue;
                        return Object.assign({}, pre);
                      });
                    }
                    if (cpDetails.billingName === "") {
                      errorTost("Please Enter Pan Number First");
                    }

                    // if (newValue !== "") {
                    //   setHelperText((pre) => {
                    //     pre.reraNumber = "";
                    //     return { ...pre };
                    //   });
                    // }
                  }}
                  placeholder="Enter RERA Number"
                  inputType="label"
                  helperText={helperText.reraNumber}
                  isLoading={isReraLoading}
                  greenTick={helperText.reraVerified}
                /> */}



                <CustomInput
                  value={cpDetails.reraNumber}
                  label={"RERA Number"}
                  mandatory={true}
                  disabled={helperText.reraVerified}
                  handleChange={(newValue) => {
                    newValue = newValue.trim();
                    var numbers = /^[a-zA-Z0-9]*$/;

                    // 1️⃣ PAN check first
                    if (!cpDetails.billingName || cpDetails.billingName.trim() === "") {
                      errorTost("Please enter PAN Number first");
                      return;
                    }

                    // 2️⃣ GST check only if applicable
                    const gstApplicable =
                      cpDetails?.gstApplicable === true || cpDetails?.gstApplicable === "true";

                    if (gstApplicable && !helperText.gstNumberVerified) {
                      errorTost("Please verify GST Number first");
                      return; // ❌ Stop here, don't proceed to RERA verification
                    }

                    // 3️⃣ Proceed with RERA verification only if format is valid
                    if (
                      cpDetails.billingName.trim() !== "" &&
                      newValue.length <= 13 &&
                      numbers.test(newValue)
                    ) {
                      // Trigger RERA verification if length matches
                      if ((newValue.length === 12 || newValue.length === 13) && newValue.length !== 0) {
                        setHelperText((pre) => {
                          pre.reraNumber = "verifying";
                          return { ...pre };
                        });
                        setIsReraLoading(true);
                        reraApiCall(newValue.toUpperCase());
                      }

                      // Mark RERA as not verified yet
                      setHelperText((pre) => {
                        pre.reraVerified = false;
                        return { ...pre };
                      });

                      // Save RERA number
                      setCpDetails((pre) => {
                        pre.reraNumber = newValue;
                        return { ...pre };
                      });
                    }
                  }}
                  placeholder="Enter RERA Number"
                  inputType="label"
                  helperText={helperText.reraNumber}
                  isLoading={isReraLoading}
                  greenTick={helperText.reraVerified}
                />





              </div>
              <div>
                <CustomInput
                  value={cpDetails.billingName}
                  label={"Billing Name"}
                  mandatory={true}
                  handleChange={(newValue) => {
                    newValue = newValue.trimStart();
                    var alphabet = /^[A-Z*\sa-z]*$/;
                    if (newValue.match(alphabet) || newValue === "") {
                      if (newValue.length <= 40) {
                        setCpDetails((pre) => {
                          pre.billingName = newValue;
                          return Object.assign({}, pre);
                        });
                      }
                    }
                    // if (newValue !== "") {
                    //   setHelperText((pre) => {
                    //     pre.isBillingName = "";
                    //     return { ...pre };
                    //   });
                    // }
                  }}
                  placeholder="Billing Name"
                  inputType="label"
                  helperText={helperText.isBillingName}
                  disabled={true}
                />
              </div>
              {/* <div>
              <div className={cssClasses.blockLabel}>
                Upload RERA Document <span style={{ color: "red" }}> *</span>
              </div>
              <div
                className={cssClasses.wrapperUploadFile}
                onClick={() => {
                  document.getElementById("imageInput").click();
                }}
              >
                {reraFileUpload === "" ? (
                  <>
                    <img
                      src={uploadFile}
                      className={cssClasses.uploadFileIcon}
                      alt=""
                    ></img>
                    <span className={cssClasses.uploadLabel}>
                      Click to Upload RERA document
                    </span>
                  </>
                ) : (
                  <span className={cssClasses.uploadLabel}>
                    {reraFileUpload}
                  </span>
                )}
                <input
                  style={{ display: "none" }}
                  type="file"
                  accept="/*"
                  id="imageInput"
                  onChange={(event) => {
                    var file = event.target.files[0];
                    var reader = new FileReader();

                    reader.onloadend = function () {
                      if (
                        event.target.files[0].type.includes("application/pdf")
                      ) {
                        setReraFileUpload(event.target.files[0].name);
                        setCpDetails((pre) => {
                          pre["reraDocument"] = event.target.files[0];
                          pre["reraDocumentName"] = event.target.files[0].name;
                          return Object.assign({}, pre);
                        });
                        if (event.target.files[0].name !== "") {
                          setHelperText((pre) => {
                            pre.reraDocument = "";
                            return { ...pre };
                          });
                        }
                      } else {
                        setReraFileUpload("");
                        setHelperText((pre) => {
                          pre.reraDocument =
                            "Please upload file in pdf format only";
                          return { ...pre };
                        });
                      }
                    };
                    reader.readAsDataURL(file);
                  }}
                />
              </div>
              {helperText.reraDocument !== "" && (
                <p
                  style={{
                    color: "#d32f2f",
                    marginTop: "0.2rem",
                    fontSize: "1.4rem",
                  }}
                >
                  {helperText.reraDocument}
                </p>
              )}
            </div> */}

              <div style={{ position: "relative" }}>
                <div className={cssClasses.blockLabel}>
                  Recommended by Sales person
                  <span style={{ color: "red" }}> *</span>
                </div>
                <ThemeProvider theme={AutoCompleTheme}>
                  <Autocomplete
                    id="free-solo-2-demo"
                    sx={{
                      fontSize: "1.6rem !important",
                      fontFamily: "Inter-Medium !important",
                      lineHeight: "2.4rem !important",
                      // borderColor: "none !important",

                      ".MuiOutlinedInput-root": {
                        background: "#F2F4F7",

                        borderRadius: "8px",
                        "&.Mui-focused": {
                          background: "#FFFFFF",
                          border: "1px solid #84CAFF !important",
                          boxShadow:
                            "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF;",
                        },
                      },
                      "& .MuiSvgIcon-root ": {
                        display: "none !important",
                      },
                    }}
                    value={cpDetails.recomendation}
                    classes={{
                      option: classes.textStyle,
                    }}
                    options={salesPersonArray.map((option) => {
                      return { label: option.name, value: option.userId };
                    })}
                    PaperComponent={({ children }) => (
                      <Paper
                        style={{
                          fontFamily: "Inter-Medium",
                          fontSize: "1.6rem",
                        }}
                      >
                        {children}
                      </Paper>
                    )}
                    onChange={(event, newValue) => {
                      console.log(newValue);
                      setCpDetails((pre) => {
                        pre.recomendation = newValue;
                        return { ...pre };
                      });
                    }}
                    onInputChange={(event, newInputValue) => {
                      // getCPEDetails(newInputValue);
                      getSalesPersonDetails(newInputValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        classes={{ root: classes.customTextField }}
                        sx={{
                          fontSize: "1.6rem !important",
                          fontFamily: "Inter-Medium !important",
                          lineHeight: "2.4rem !important",
                          textTransform: "capitalize",
                          " .MuiFormHelperText-root ": {
                            fontSize: "1.4rem !important",
                            fontFamily: "Inter-Medium",
                            lineHeight: "2rem",
                            marginLeft: "0rem !important",
                          },
                        }}
                        placeholder="Search Sales Person Name *"
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          type: "search",
                          style: { fontSize: "1.6rem" },
                        }}
                        onChange={(e, v) => {
                          // getCPEDetails(e.target.value);
                          getSalesPersonDetails(e.target.value);
                        }}
                        helperText={helperText.salesPersonName}
                        error={helperText.salesPersonName}
                      />
                    )}
                  />
                </ThemeProvider>
              </div>
              <div>
                <div className={cssClasses.blockLabel}>
                  MSME Type <span style={{ color: "red" }}> *</span>
                </div>
                <Dropdown
                  // isError={helperText.isTypeFilled}/
                  list={MSMEList}
                  placeHolder={"MSME Type"}
                  // label={' MSME Type'}
                  // mark={true}
                  selectedValue={cpDetails.msmeAvalaible}
                  style={{ background: "#F2F4F7", color: "rgb(102, 112, 133)" }}
                  onChangeSelect={(_value) => {
                    cpDetails.msmeNumber = "";
                    setCpDetails((pre) => {
                      pre["msmeAvalaible"] = _value;
                      return Object.assign({}, pre);
                    });
                    setHelperText((pre) => {
                      pre.isMemeNumber = "";
                      pre.msmeNumber = "";
                      return Object.assign({}, pre);
                    });
                  }}
                  helperText={helperText.isMemeNumber}
                />
              </div>
              {cpDetails.msmeAvalaible !== "Not Applicable" &&
                cpDetails.msmeAvalaible !== "" && (
                  <div>
                    <CustomInput
                      value={cpDetails.msmeNumber}
                      label={"MSME Number"}
                      mandatory={true}
                      handleChange={(newValue) => {
                        var numbers = /^[0-9]*$/;
                        if (newValue.match(numbers) || newValue === "") {
                          if (newValue.length <= 12) {
                            setCpDetails((pre) => {
                              pre.msmeNumber = newValue;
                              return Object.assign({}, pre);
                            });
                          }
                        }

                        if (newValue !== "") {
                          setHelperText((pre) => {
                            pre.msmeNumber = "";
                            return { ...pre };
                          });
                        } else {
                          setHelperText((pre) => {
                            pre.msmeNumber = "Please Enter MSME Number";
                            return { ...pre };
                          });
                        }
                      }}
                      placeholder="MSME Number"
                      inputType="label"
                      helperText={helperText.msmeNumber}
                    />
                  </div>
                )}
            </div>
            <div>
              {cpButtonNext ? (
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                    border: "1px solid #155EEF",
                  }}
                  btnName={"Proceed"}
                  clicked={validateCpDetails}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              ) : (
                <Button
                  style={{
                    color: "#155EEF",
                    backgroundColor: "#ffffff",
                    border: "1px solid #155EEF",
                  }}
                  btnName={"Proceed"}
                  clicked={validateCpDetails}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              )}
            </div>
          </div>
        )}
        {activeStep === 4 && (
          <div className={cssClasses.wrapperContactDeatils}>
            {/* //! as per Rohit jadhav's change on trello */}
            <div className={cssClasses.detailText}>Company Owner Details</div>
            {/* <div className={cssClasses.detailText}>Contact Person Details</div> */}
            <div className={cssClasses.wrapperInnerContent}>
              <div style={{ textTransform: "uppercase" }}>
                <CustomInput
                  value={personDetail.personaName}
                  label={"Person Name"}
                  mandatory={true}
                  handleChange={(newValue) => {
                    newValue = newValue.trimStart();
                    var alphabet = /^[A-Z*\sa-z]*$/;
                    if (newValue.match(alphabet) || newValue === "") {
                      if (newValue.length <= 40) {
                        setPersonDetail((pre) => {
                          pre.personaName = newValue;
                          return Object.assign({}, pre);
                        });
                      }
                    }

                    if (newValue !== "") {
                      setHelperText((pre) => {
                        pre.isPersonName = "";
                        return { ...pre };
                      });
                    } else {
                      setHelperText((pre) => {
                        pre.isPersonName = "Please Enter Person Name";
                        return { ...pre };
                      });
                    }
                  }}
                  placeholder="Enter contact person name"
                  inputType="label"
                  helperText={helperText.isPersonName}
                />
              </div>
              <div style={{ position: "relative" }}>
                <div className={cssClasses.blockLabel}>
                  Phone Number <span style={{ color: "red" }}> *</span>
                </div>
                <PhoneInput
                  defaultCountry="IN"
                  disabled={showOtp || verifiedPhoneNumber || resendButton}
                  value={personDetail.phoneNumber}
                  placeholder="Enter phone number"
                  onChange={(phone) => {
                    console.log(phone);
                    if (phone?.length > 0 && phone !== undefined) {
                      phone = phone.trim();
                    }
                    setPersonDetail((pre) => {
                      pre["phoneNumber"] = phone;
                      return Object.assign({}, pre);
                    });
                    if (phone !== undefined) {
                      setVerifiedPhoneNumber(false);
                      if (phone.length >= 1) {
                        if (isValidPhoneNumber(phone) === false) {
                          setVerifiedPhoneNumber(false);

                          setHelperText((pre) => ({
                            ...pre,
                            isPhoneNumber: "Please Enter valid Phone Number",
                          }));

                          setShowOtp(false);
                        } else {
                          setHelperText((pre) => ({
                            ...pre,
                            isPhoneNumber: "verifying...",
                          }));

                          if (phone?.substring(0, 3) === "+91") {
                            setIsInterNational(false);
                          } else {
                            setIsInterNational(true);
                          }

                          // ✅ Step 1: Check duplicate
                          checkPhoneExists(phone);
                        }
                      }
                    } else {
                      helperText.isPhoneNumber = "Please Enter  Phone Number";
                      setShowOtp(false);
                    }
                  }}
                />
                <p
                  style={{
                    color: "red",
                    fontSize: "1.4rem",
                    lineHeight: "1.66",
                  }}
                >
                  {helperText.isPhoneNumber}
                </p>
                {helperText.isPhoneNumber === "" &&
                  verifiedPhoneNumber === false &&
                  otptimer === false &&
                  showOtp === false &&
                  personDetail.phoneNumber !== "" && (
                    <div
                      className={cssClasses.verifyOtp}
                      onClick={() => {
                        smsApiCall();
                      }}
                    >
                      Verify Otp
                    </div>
                  )}
                {verifiedPhoneNumber === false &&
                  showOtp === true &&
                  resendButton === false && (
                    <div className={cssClasses.resendOtp}>
                      {" "}
                      Resend Otp in{" "}
                      {/* <Countdown date={startDate.current + 180000} renderer={renderer} /> */}
                      <CountdownTimer
                        startFrom={180}
                        onComplete={() => {
                          setResendButton(true);
                        }}
                        timeFormatter={(time) => {
                          return (
                            <span>
                              {`0${Math.floor(time / 60)}`.slice(-2)}:
                              {`0${time % 60}`.slice(-2)}
                            </span>
                          );
                        }}
                      />
                    </div>
                  )}
                {verifiedPhoneNumber === false &&
                  showOtp === true &&
                  resendButton === true && (
                    <div
                      className={cssClasses.verifyOtp}
                      id="resendCount"
                      onClick={() => {
                        setHelperText((pre) => {
                          pre.isPhoneNumber = "";
                          return { ...pre };
                        });
                        if (resendButton) {
                          smsApiCall();
                          // successTost("Otp has been sent");
                        } else {
                          document.getElementById(
                            "resendCount"
                          ).disabled = true;
                          console.log("Please wait for 3 min");
                        }
                      }}
                    >
                      Resend Otp
                    </div>
                  )}
                {helperText.isPhoneNumber === "" &&
                  verifiedPhoneNumber &&
                  otptimer === false && (
                    <div className={cssClasses.verifyOtp}>
                      <CheckCircleSharpIcon
                        style={{ fontSize: "2.5rem", marginRight: "1rem" }}
                        color={"success"}
                      />
                    </div>
                  )}
                {showOtp && (
                  <div className={cssClasses.otpContainer}>
                    <input
                      className={cssClasses.otpInput}
                      name="otp1"
                      type="text"
                      autoComplete="off"
                      value={state.otp1}
                      // onKeyPress={keyPressed}
                      onChange={(e) => optChange("otp1", e)}
                      tabIndex="1"
                      maxLength="1"
                      onKeyUp={(e) => inputfocus(e)}
                      id="opt-0"
                    />
                    <input
                      name="otp2"
                      type="text"
                      autoComplete="off"
                      className={cssClasses.otpInput}
                      value={state.otp2}
                      onChange={(e) => optChange("otp2", e)}
                      tabIndex="2"
                      maxLength="1"
                      onKeyUp={(e) => inputfocus(e)}
                      id="opt-1"
                    />
                    <input
                      name="otp3"
                      type="text"
                      autoComplete="off"
                      className={cssClasses.otpInput}
                      value={state.otp3}
                      onChange={(e) => optChange("otp3", e)}
                      tabIndex="3"
                      maxLength="1"
                      onKeyUp={(e) => inputfocus(e)}
                      id="opt-2"
                    />
                    <input
                      name="otp4"
                      type="text"
                      autoComplete="off"
                      className={cssClasses.otpInput}
                      value={state.otp4}
                      onChange={(e) => optChange("otp4", e)}
                      tabIndex="4"
                      maxLength="1"
                      onKeyUp={(e) => inputfocus(e)}
                      id="opt-3"
                    />

                    <div>
                      <Button
                        tabIndex={5}
                        style={{
                          color: "#ffffff",
                          backgroundColor: "#155EEF",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                        }}
                        btnName={"Submit OTP"}
                        clicked={submitOtp}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div>
                <CustomInput
                  value={personDetail.email}
                  greenTick={verifiedEmail}
                  label={"Email Id"}
                  mandatory={true}
                  inputType={"label"}
                  position={"end"}
                  labelText={emailLabelText}  // 'Send Otp' or empty based on existence
                  disabled={showEmailOtp || verifiedEmail}  // Disable if email exists
                  clicked={(e) => {
                    if (e === 'Send Otp') {
                      // Check if email exists when 'Send Otp' is clicked
                      setIsLoadingEmail(true);
                      checkEmailExists(personDetail.email.trimStart());
                      sendOtpToVerifyEmail(e);
                    } else if (e === 'Resend Otp') {
                      sendOtpToVerifyEmail(e);
                    }
                  }}
                  handleChange={(newValue) => {
                    newValue = newValue.trimStart();
                    const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!newValue.trim()) {
                      helperText.isEmail = "Please Enter Email Id";
                    } else if (!newValue.match(emailIDCond)) {
                      helperText.isEmail = "Please Enter Email in Proper Format";
                    } else {
                      // If the email format is correct, enable the OTP verification
                      setIsLoadingEmail(true);
                      checkEmailExists(newValue);
                      helperText.isEmail = "verifying...";
                    }
                    setPersonDetail((pre) => {
                      pre.email = newValue;
                      return Object.assign({}, pre);
                    });
                  }}
                  placeholder="Enter contact person Email"
                  helperText={helperText.isEmail}
                  isLoading={isLoadingEmail}
                />
                {otptimerEmail && (

                  <div className={cssClasses.resendOtp}>
                    {" "}
                    Resend Otp in{" "}
                    <CountdownTimer startFrom={180} onComplete={() => { setEmailLabelText('Resend Otp'); setOtpTimerEmail(false); }}
                      timeFormatter={(time) => {
                        return (<span>{`0${Math.floor(time / 60)}`.slice(-2)}:{`0${time % 60}`.slice(-2)}</span>)
                      }}
                    />
                  </div>
                )}
                {showEmailOtp && (
                  <div className={cssClasses.otpContainer}>
                    <input
                      className={cssClasses.otpInput}
                      name="otp1"
                      type="text"
                      autoComplete="off"
                      value={emailState.otp1}
                      // onKeyPress={keyPressed}
                      onChange={(e) => optEmailChange("otp1", e)}
                      tabIndex="1"
                      maxLength="1"
                      onKeyUp={(e) => inputfocus(e)}
                      id='opt-0'
                    />
                    <input
                      name="otp2"
                      type="text"
                      autoComplete="off"
                      className={cssClasses.otpInput}
                      value={emailState.otp2}
                      onChange={(e) => optEmailChange("otp2", e)}
                      tabIndex="2"
                      maxLength="1"
                      onKeyUp={(e) => inputfocus(e)}
                      id='opt-1'
                    />
                    <input
                      name="otp3"
                      type="text"
                      autoComplete="off"
                      className={cssClasses.otpInput}
                      value={emailState.otp3}
                      onChange={(e) => optEmailChange("otp3", e)}
                      tabIndex="3"
                      maxLength="1"
                      onKeyUp={(e) => inputfocus(e)}
                      id='opt-2'
                    />
                    <input
                      name="otp4"
                      type="text"
                      autoComplete="off"
                      className={cssClasses.otpInput}
                      value={emailState.otp4}
                      onChange={(e) => optEmailChange("otp4", e)}
                      tabIndex="4"
                      maxLength="1"
                      onKeyUp={(e) => inputfocus(e)}
                      id='opt-3'
                    />

                    <div>
                      <Button
                        tabIndex={5}
                        style={{
                          color: "#ffffff",
                          backgroundColor: "#155EEF",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                        }}
                        btnName={"Submit OTP"}
                        clicked={submitEmailOtp}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div>
                <CustomInput
                  value={personDetail.password}
                  label={"Passsword"}
                  mandatory={true}
                  handleChange={(newValue) => {
                    newValue = newValue.trim();
                    if (newValue.search(/[A-Z]/) < 0) {
                      helperText.isPassword =
                        "Password should contain atleast 1 Uppercase.";
                    } else if (newValue.search(/[a-z]/) < 0) {
                      helperText.isPassword =
                        "Password should contain atleast 1 LowerCase.";
                    } else if (newValue.search(/[0-9]/) < 0) {
                      helperText.isPassword =
                        "Password should contain atleast 1 number.";
                    } else if (newValue.length < 6) {
                      helperText.isPassword =
                        "Password should contain atleast 6 Characters.";
                    } else {
                      helperText.isPassword = "";
                    }
                    setPersonDetail((pre) => {
                      pre.password = newValue;
                      return Object.assign({}, pre);
                    });
                  }}
                  placeholder="Enter contact person Password"
                  inputType="password"
                  helperText={helperText.isPassword}
                />
              </div>
            </div>
            <div>
              {personalButtonNext ? (
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                    border: "1px solid #155EEF",
                  }}
                  btnName={"Proceed"}
                  clicked={validatePersonaDetails}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              ) : (
                <Button
                  style={{
                    color: "#155EEF",
                    backgroundColor: "#ffffff",
                    border: "1px solid #155EEF",
                  }}
                  btnName={"Proceed"}
                  clicked={validatePersonaDetails}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              )}
            </div>
          </div>
        )}
        {activeStep === 5 && (
          <div className={cssClasses.wrapperContactDeatils}>
            <div className={cssClasses.detailText}>Bank Detalis</div>
            <div className={cssClasses.wrapperInnerContent}>
              <div>
                <CustomInput
                  value={bankDetails.accountNumber}
                  disabled={helperText.bankDetailsIsVerified}
                  label={"Account Number"}
                  mandatory={true}
                  handleChange={(newValue) => {
                    const numbers = /^[0-9]*$/;
                    if ((numbers.test(newValue) || newValue === "") && newValue.length <= 18) {
                      setBankDetails((pre) => ({ ...pre, accountNumber: newValue }));
                      // reset helper + verification state (no auto verify)
                      if (newValue === "") {
                        setHelperText((pre) => ({ ...pre, isAccountNumber: "Please Enter Account Number", bankDetailsIsVerified: false }));
                      } else {
                        setHelperText((pre) => ({ ...pre, isAccountNumber: "", bankDetailsIsVerified: false }));
                      }
                    }
                  }}
                  placeholder="Account Number"
                  inputType="label"
                  isLoading={isLoadingAccount}
                  helperText={helperText.isAccountNumber}
                  greenTick={helperText.bankDetailsIsVerified}
                />

              </div>
              <div>
                {(() => {
                  const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;
                  const canVerifyBank =
                    !!bankDetails.accountNumber &&
                    !!bankDetails.ifscCode &&
                    IFSC_REGEX.test((bankDetails.ifscCode || "").toUpperCase()) &&
                    !helperText.bankDetailsIsVerified &&
                    !isLoadingIfSC &&
                    !isLoadingAccount;

                  return (
                    <CustomInput
                      value={bankDetails.ifscCode}
                      label={"IFSC Code"}
                      mandatory={true}
                      disabled={helperText.bankDetailsIsVerified}
                      inputType="label"
                      position="end"
                      labelText={canVerifyBank ? "Verify" : ""}   // 👈 shows the button only when valid
                      clicked={() => {
                        // manual verify on click
                        const IFSC = (bankDetails.ifscCode || "").toUpperCase();
                        const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;

                        if (!bankDetails.accountNumber) {
                          setHelperText((pre) => ({ ...pre, isAccountNumber: "Please Enter Account Number" }));
                          return;
                        }
                        if (!IFSC_REGEX.test(IFSC)) {
                          setHelperText((pre) => ({ ...pre, isIfscCode: "Please Enter Valid Ifsc code" }));
                          return;
                        }

                        // show verifying state for both fields
                        setHelperText((pre) => ({
                          ...pre,
                          isAccountNumber: "verifying...",
                          isIfscCode: "verifying...",
                          bankDetailsIsVerified: false,
                        }));
                        setIsLoadingIfSC(true);
                        setIsLoadingAccount(true);

                        // kick off verification (same function you already have)
                        checkBankDetails(bankDetails.accountNumber, IFSC);
                      }}
                      handleChange={(newValue) => {
                        const val = newValue.trimStart().toUpperCase();
                        // update IFSC only (no auto verify)
                        if (val.length <= 11) {
                          setBankDetails((pre) => ({ ...pre, ifscCode: val }));
                          setHelperText((pre) => ({
                            ...pre,
                            isIfscCode: val === "" ? "Please Enter IFSC Code" : "",
                            bankDetailsIsVerified: false,
                          }));
                        }
                      }}
                      placeholder="IFSC Code"
                      isLoading={isLoadingIfSC || isLoadingAccount}
                      helperText={helperText.isIfscCode}
                      greenTick={helperText.bankDetailsIsVerified}
                    />
                  );
                })()}

              </div>
              <div style={{ textTransform: "uppercase" }}>
                <CustomInput
                  value={bankDetails.holderName}
                  label={"Account Holder Name"}
                  mandatory={true}
                  handleChange={(newValue) => {
                    newValue = newValue.trimStart();
                    var alphabet = /^[A-Z*\sa-z]*$/;
                    if (newValue.match(alphabet) || newValue === "") {
                      if (newValue.length <= 40) {
                        setBankDetails((pre) => {
                          pre.holderName = newValue;
                          return Object.assign({}, pre);
                        });
                      }
                    }

                    // if (newValue === "") {
                    //   helperText.isHolderName = "Please Enter Holder Name";
                    // } else {
                    //   helperText.isHolderName = "";
                    // }
                  }}
                  placeholder="Account Holder Name"
                  inputType="label"
                  helperText={helperText.isHolderName}
                  disabled={true}
                />
              </div>
              <div>
                <CustomInput
                  value={bankDetails.branchName}
                  label={"Branch Name"}
                  mandatory={true}
                  handleChange={(newValue) => {
                    newValue = newValue.trimStart();
                    newValue = newValue.toUpperCase();
                    var alphabet = /^[A-Z*\sa-z]*$/;
                    if (newValue.match(alphabet) || newValue === "") {
                      if (newValue.length <= 40) {
                        setBankDetails((pre) => {
                          pre.branchName = newValue;
                          return Object.assign({}, pre);
                        });
                      }
                    }
                    if (newValue === "") {
                      helperText.isBranchName = "Please Enter Branch Name";
                    } else {
                      helperText.isBranchName = "";
                    }
                  }}
                  placeholder="Branch Name"
                  inputType="label"
                  helperText={helperText.isBranchName}
                />
              </div>
            </div>
            <div>
              {bankButtonNext ? (
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "#155EEF",
                    border: "1px solid #155EEF",
                  }}
                  btnName={"Proceed"}
                  clicked={validateBankDetails}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              ) : (
                <Button
                  style={{
                    color: "#155EEF",
                    backgroundColor: "#ffffff",
                    border: "1px solid #155EEF",
                  }}
                  btnName={"Proceed"}
                  clicked={validateBankDetails}
                  btnIcon={<RightArrow />}
                  iconPosition={"right"}
                />
              )}
            </div>
          </div>
        )}
        {activeStep === 6 && (
          <div className={cssClasses.wrapperDetailsSubmitted}>
            <div>
              <img
                src={greenCheckedIcon}
                alt="CheckedIcon"
                className={cssClasses.greenCheckedIcon}
              ></img>
            </div>
            <div>
              <div className={cssClasses.detailText}>Details Submited</div>
            </div>
            <div>
              <div className={cssClasses.subDetailText}>
                You have submitted your details successfully. Your account will
                be verified soon.
              </div>
            </div>
            <div>
              <span className={cssClasses.subDetailText}>
                Your Id: {cpDispalyId}{" "}
              </span>
              <ContentCopyIcon
                className={cssClasses.copyIcon}
                onClick={() => {
                  copy(cpDispalyId, {
                    debug: true,
                    message: "Press #{key} to copy",
                  });
                  successTost("id is copied");
                }}
              />
              <div className={cssClasses.textCopy}>
                Please copy this id you need this while login{" "}
              </div>
              <div className={cssClasses.wrapperCirucularProgress}>
                <span style={{ marginRight: "1rem" }}>
                  Redirecting in {counting}
                </span>
                <span style={{ color: "#155EEF" }}>
                  <CircularProgress
                    variant="determinate"
                    value={progress}
                    color="inherit"
                    sx={[
                      {
                        width: "30px !important",
                        height: "30px !important",
                      },
                    ]}
                  />
                </span>
              </div>
            </div>
            <div>
              <Button
                style={{
                  color: "#ffffff",
                  backgroundColor: "#155EEF",
                  border: "1px solid #155EEF",
                }}
                btnName={"Goback"}
                clicked={() => {
                  navigate("/Login");
                }}
              />
            </div>
          </div>
        )}
      </div>

      <ConfirmationAlert
        open={openConfirmation}
        close={() => {
          setOpenConfirmation(false);
        }}
        icon={<InfoIcon width={"4.8rem"} height={"4.8rem"} />}
        title={"Info !"}
        subTitle={message}
        confirm={(value) => {

          if (value === "confirmed") {
            setCpDetails((prev) => {
              console.log(prev);
              prev.billingName = ledgerName;
              return { ...prev };
            });
            setCpDetails((pre) => {
              pre.isFlagged = true;
              return { ...pre };
            });
            if (reraPopUp) {
              setReraPopUpYesSelected(true);
            }
          } else if (value === "rejected") {

            setCpDetails((pre) => {
              pre.isFlagged = true;
              return { ...pre };
            });
            if (reraPopUp) {
              setReraPopUpYesSelected(false);
            }
          }

          setOpenConfirmation(false);
          console.log(value);
        }}
        buttonTitle={"No"}
        returnRespButton={"Yes"}
      />
    </div>





  );


}
